var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessTransaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 313.586,
    height: 325.109,
    viewBox: "0 0 313.586 325.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7754",
    "data-name": "Group 7754",
    transform: "translate(-551.708 -112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_4365500",
    "data-name": 4365500,
    transform: "translate(551.708 112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    transform: "translate(0 7.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6655",
    "data-name": "Group 6655",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6518",
    "data-name": "Group 6518",
    transform: "translate(4.984 60.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6251",
    "data-name": "Group 6251",
    transform: "translate(6.891 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6214",
    "data-name": "Group 6214",
    transform: "translate(0 0.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6213",
    "data-name": "Group 6213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6212",
    "data-name": "Group 6212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6211",
    "data-name": "Group 6211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6210",
    "data-name": "Group 6210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11727",
    "data-name": "Path 11727",
    d: "M51.536,126.436s-4.431,3.378-.183,7.838a.4.4,0,0,0,.278.117l38.723-.227a6.754,6.754,0,0,0,.563-7.984Z",
    transform: "translate(-49.511 -126.18)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6220",
    "data-name": "Group 6220",
    transform: "translate(10.748 3.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6219",
    "data-name": "Group 6219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6218",
    "data-name": "Group 6218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6217",
    "data-name": "Group 6217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6216",
    "data-name": "Group 6216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6215",
    "data-name": "Group 6215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11728",
    "data-name": "Path 11728",
    d: "M85.75,131.32c0,.044-4.826.08-10.77.08s-10.77-.037-10.77-.08,4.818-.08,10.77-.08S85.75,131.277,85.75,131.32Z",
    transform: "translate(-64.21 -131.24)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6226",
    "data-name": "Group 6226",
    transform: "translate(16.136 5.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6225",
    "data-name": "Group 6225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6224",
    "data-name": "Group 6224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6223",
    "data-name": "Group 6223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6222",
    "data-name": "Group 6222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6221",
    "data-name": "Group 6221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11729",
    "data-name": "Path 11729",
    d: "M81.707,133.24c0,.044-2.267.08-5.06.08s-5.067-.037-5.067-.08,2.267-.08,5.067-.08S81.707,133.2,81.707,133.24Z",
    transform: "translate(-71.58 -133.16)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6232",
    "data-name": "Group 6232",
    transform: "translate(36.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6231",
    "data-name": "Group 6231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6230",
    "data-name": "Group 6230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6229",
    "data-name": "Group 6229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6228",
    "data-name": "Group 6228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6227",
    "data-name": "Group 6227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11730",
    "data-name": "Path 11730",
    d: "M99.062,134c-.022-.007.088-.446.2-1.163a15.917,15.917,0,0,0-.051-5.645c-.132-.717-.249-1.148-.227-1.155a1.334,1.334,0,0,1,.11.3c.066.2.139.483.219.841a13.646,13.646,0,0,1,.322,2.844,14.141,14.141,0,0,1-.271,2.844c-.073.358-.146.643-.2.841A1.438,1.438,0,0,1,99.062,134Z",
    transform: "translate(-98.986 -126.04)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6238",
    "data-name": "Group 6238",
    transform: "translate(39.136 0.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6237",
    "data-name": "Group 6237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6236",
    "data-name": "Group 6236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6235",
    "data-name": "Group 6235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6234",
    "data-name": "Group 6234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6233",
    "data-name": "Group 6233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11731",
    "data-name": "Path 11731",
    d: "M103.039,126.12a1.311,1.311,0,0,1,.175.278c.051.1.11.2.175.344s.139.292.2.475a8.133,8.133,0,0,1,.366,1.287,9.309,9.309,0,0,1,.168,1.631,10.192,10.192,0,0,1-.139,1.63,7.594,7.594,0,0,1-.351,1.294c-.059.183-.132.336-.19.475s-.117.256-.168.351a1.5,1.5,0,0,1-.168.285c-.029-.015.19-.431.417-1.148a8.684,8.684,0,0,0,.307-1.28,9.211,9.211,0,0,0,.124-1.609,9.757,9.757,0,0,0-.154-1.6,9.089,9.089,0,0,0-.329-1.272C103.236,126.544,103.01,126.134,103.039,126.12Z",
    transform: "translate(-103.037 -126.12)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6244",
    "data-name": "Group 6244",
    transform: "translate(7.033 0.431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6243",
    "data-name": "Group 6243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6242",
    "data-name": "Group 6242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6241",
    "data-name": "Group 6241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6240",
    "data-name": "Group 6240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6239",
    "data-name": "Group 6239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11732",
    "data-name": "Path 11732",
    d: "M60.234,134.212a1.358,1.358,0,0,1-.183-.256,2.959,2.959,0,0,1-.183-.322,3.666,3.666,0,0,1-.2-.446,6.716,6.716,0,0,1-.38-1.221,7.976,7.976,0,0,1-.154-1.557,7.893,7.893,0,0,1,.19-1.557,7.114,7.114,0,0,1,.409-1.214,4.076,4.076,0,0,1,.219-.439,2.208,2.208,0,0,1,.19-.314c.11-.168.175-.263.19-.256s-.219.388-.5,1.053a7.817,7.817,0,0,0-.373,1.2,8.122,8.122,0,0,0-.175,1.528,7.5,7.5,0,0,0,.468,2.735C60.022,133.817,60.263,134.2,60.234,134.212Z",
    transform: "translate(-59.13 -126.629)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6250",
    "data-name": "Group 6250",
    transform: "translate(2.653 0.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6249",
    "data-name": "Group 6249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6248",
    "data-name": "Group 6248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6247",
    "data-name": "Group 6247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6246",
    "data-name": "Group 6246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6245",
    "data-name": "Group 6245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11733",
    "data-name": "Path 11733",
    d: "M54.441,135.141a1.644,1.644,0,0,1-.2-.292c-.058-.1-.132-.219-.2-.366a5.377,5.377,0,0,1-.234-.5,8.345,8.345,0,0,1-.446-1.367,9.664,9.664,0,0,1-.219-1.748,10.107,10.107,0,0,1,.139-1.755,8.221,8.221,0,0,1,.38-1.382c.066-.2.146-.358.212-.512s.132-.271.183-.373a1.639,1.639,0,0,1,.183-.3c.029.015-.219.453-.483,1.221a9.4,9.4,0,0,0-.344,1.375,9.875,9.875,0,0,0-.124,1.726,9.456,9.456,0,0,0,.2,1.718,9.909,9.909,0,0,0,.4,1.36C54.2,134.7,54.471,135.119,54.441,135.141Z",
    transform: "translate(-53.139 -126.55)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6328",
    "data-name": "Group 6328",
    transform: "translate(0 19.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6292",
    "data-name": "Group 6292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6256",
    "data-name": "Group 6256",
    transform: "translate(31.977 0.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6255",
    "data-name": "Group 6255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6254",
    "data-name": "Group 6254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6253",
    "data-name": "Group 6253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6252",
    "data-name": "Group 6252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11734",
    "data-name": "Path 11734",
    d: "M98.158,153.23v7.414H83.82V153.23Z",
    transform: "translate(-83.82 -153.23)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6261",
    "data-name": "Group 6261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6260",
    "data-name": "Group 6260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6259",
    "data-name": "Group 6259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6258",
    "data-name": "Group 6258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6257",
    "data-name": "Group 6257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11735",
    "data-name": "Path 11735",
    d: "M40.089,156.713c0,.066.007.132.007.2a4.243,4.243,0,0,0,4.263,3.978H87.067v-.534H76.933a3.707,3.707,0,0,1-3.707-3.707h0a3.707,3.707,0,0,1,3.707-3.707H87.074v-.79l-42.722.146A4.274,4.274,0,0,0,40.089,156.713Z",
    transform: "translate(-40.086 -152.15)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6267",
    "data-name": "Group 6267",
    transform: "translate(33.14 4.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6266",
    "data-name": "Group 6266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6265",
    "data-name": "Group 6265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6264",
    "data-name": "Group 6264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6263",
    "data-name": "Group 6263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6262",
    "data-name": "Group 6262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11736",
    "data-name": "Path 11736",
    d: "M98.586,158.41c0,.044-2.947.08-6.588.08s-6.588-.037-6.588-.08,2.947-.08,6.588-.08S98.586,158.367,98.586,158.41Z",
    transform: "translate(-85.41 -158.33)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6273",
    "data-name": "Group 6273",
    transform: "translate(33.651 6.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6272",
    "data-name": "Group 6272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6271",
    "data-name": "Group 6271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6270",
    "data-name": "Group 6270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6269",
    "data-name": "Group 6269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6268",
    "data-name": "Group 6268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11737",
    "data-name": "Path 11737",
    d: "M98.569,160.69c0,.044-2.793.08-6.23.08s-6.23-.037-6.23-.08,2.786-.08,6.23-.08S98.569,160.647,98.569,160.69Z",
    transform: "translate(-86.11 -160.61)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6279",
    "data-name": "Group 6279",
    transform: "translate(35.114 7.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6278",
    "data-name": "Group 6278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6277",
    "data-name": "Group 6277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6276",
    "data-name": "Group 6276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6275",
    "data-name": "Group 6275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6274",
    "data-name": "Group 6274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11738",
    "data-name": "Path 11738",
    d: "M99.312,162.78c0,.044-2.508.08-5.6.08s-5.6-.037-5.6-.08,2.508-.08,5.6-.08S99.312,162.737,99.312,162.78Z",
    transform: "translate(-88.11 -162.7)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6285",
    "data-name": "Group 6285",
    transform: "translate(33.418 3.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6284",
    "data-name": "Group 6284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6283",
    "data-name": "Group 6283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6282",
    "data-name": "Group 6282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6281",
    "data-name": "Group 6281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6280",
    "data-name": "Group 6280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11739",
    "data-name": "Path 11739",
    d: "M98.688,156.35c0,.044-2.888.08-6.449.08s-6.449-.037-6.449-.08,2.888-.08,6.449-.08S98.688,156.307,98.688,156.35Z",
    transform: "translate(-85.79 -156.27)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6291",
    "data-name": "Group 6291",
    transform: "translate(34.631 1.514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6290",
    "data-name": "Group 6290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6289",
    "data-name": "Group 6289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6288",
    "data-name": "Group 6288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6287",
    "data-name": "Group 6287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6286",
    "data-name": "Group 6286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11740",
    "data-name": "Path 11740",
    d: "M98.929,154.3c0,.044-2.574.08-5.74.08s-5.74-.037-5.74-.08,2.574-.08,5.74-.08S98.929,154.257,98.929,154.3Z",
    transform: "translate(-87.45 -154.22)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6298",
    "data-name": "Group 6298",
    transform: "translate(3.147 0.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6297",
    "data-name": "Group 6297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6296",
    "data-name": "Group 6296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6295",
    "data-name": "Group 6295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6294",
    "data-name": "Group 6294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6293",
    "data-name": "Group 6293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11741",
    "data-name": "Path 11741",
    d: "M46.423,152.52a8.971,8.971,0,0,0-.907,1.082,5.49,5.49,0,0,0,.08,6.354,9.565,9.565,0,0,0,.936,1.06,1.4,1.4,0,0,1-.307-.227,4.76,4.76,0,0,1-.717-.768,5.4,5.4,0,0,1-.08-6.478,5.052,5.052,0,0,1,.695-.782A1.431,1.431,0,0,1,46.423,152.52Z",
    transform: "translate(-44.39 -152.519)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6304",
    "data-name": "Group 6304",
    transform: "translate(1.706 0.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6303",
    "data-name": "Group 6303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6302",
    "data-name": "Group 6302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6301",
    "data-name": "Group 6301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6300",
    "data-name": "Group 6300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6299",
    "data-name": "Group 6299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11742",
    "data-name": "Path 11742",
    d: "M44.453,152.31a8.971,8.971,0,0,0-.907,1.082,5.49,5.49,0,0,0,.08,6.354,9.564,9.564,0,0,0,.936,1.06,1.4,1.4,0,0,1-.307-.227,4.759,4.759,0,0,1-.717-.768,5.4,5.4,0,0,1-.08-6.478,5.052,5.052,0,0,1,.695-.782A1.04,1.04,0,0,1,44.453,152.31Z",
    transform: "translate(-42.42 -152.309)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6310",
    "data-name": "Group 6310",
    transform: "translate(30.719 0.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6309",
    "data-name": "Group 6309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6308",
    "data-name": "Group 6308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6307",
    "data-name": "Group 6307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6306",
    "data-name": "Group 6306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6305",
    "data-name": "Group 6305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11743",
    "data-name": "Path 11743",
    d: "M84.133,152.52a8.971,8.971,0,0,0-.907,1.082,5.49,5.49,0,0,0,.08,6.354,9.565,9.565,0,0,0,.936,1.06,1.4,1.4,0,0,1-.307-.227,4.759,4.759,0,0,1-.717-.768,5.4,5.4,0,0,1-.08-6.478,5.052,5.052,0,0,1,.695-.782A1.7,1.7,0,0,1,84.133,152.52Z",
    transform: "translate(-82.1 -152.519)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6316",
    "data-name": "Group 6316",
    transform: "translate(29.279 0.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6315",
    "data-name": "Group 6315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6314",
    "data-name": "Group 6314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6313",
    "data-name": "Group 6313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6312",
    "data-name": "Group 6312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6311",
    "data-name": "Group 6311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11744",
    "data-name": "Path 11744",
    d: "M82.163,152.31a8.971,8.971,0,0,0-.907,1.082,5.49,5.49,0,0,0,.08,6.354,9.562,9.562,0,0,0,.936,1.06,1.4,1.4,0,0,1-.307-.227,4.759,4.759,0,0,1-.717-.768,5.4,5.4,0,0,1-.08-6.478,5.052,5.052,0,0,1,.695-.782A1.169,1.169,0,0,1,82.163,152.31Z",
    transform: "translate(-80.13 -152.309)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6321",
    "data-name": "Group 6321",
    transform: "translate(7.789 1.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6320",
    "data-name": "Group 6320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6319",
    "data-name": "Group 6319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6318",
    "data-name": "Group 6318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6317",
    "data-name": "Group 6317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11745",
    "data-name": "Path 11745",
    d: "M52.992,158.233c-.015-1-.029-2.011-.044-3.012a1.975,1.975,0,0,0-.11-.775.726.726,0,0,0-.57-.483,1.138,1.138,0,0,0-1.228.585,2.887,2.887,0,0,0-.3,1.477,20.015,20.015,0,0,0,.117,2.384,2.791,2.791,0,0,0,.278,1.089.909.909,0,0,0,1.726-.146A3.054,3.054,0,0,0,52.992,158.233Z",
    transform: "translate(-50.739 -153.917)",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6327",
    "data-name": "Group 6327",
    transform: "translate(12.835 4.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6326",
    "data-name": "Group 6326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6325",
    "data-name": "Group 6325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6324",
    "data-name": "Group 6324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6323",
    "data-name": "Group 6323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6322",
    "data-name": "Group 6322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11746",
    "data-name": "Path 11746",
    d: "M71.43,158.6c0,.044-3.086.08-6.895.08s-6.895-.037-6.895-.08,3.086-.08,6.895-.08S71.43,158.557,71.43,158.6Z",
    transform: "translate(-57.64 -158.52)",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6482",
    "data-name": "Group 6482",
    transform: "translate(6.898 11.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6419",
    "data-name": "Group 6419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6364",
    "data-name": "Group 6364",
    transform: "translate(0.205 0.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6333",
    "data-name": "Group 6333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6332",
    "data-name": "Group 6332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6331",
    "data-name": "Group 6331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6330",
    "data-name": "Group 6330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6329",
    "data-name": "Group 6329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11747",
    "data-name": "Path 11747",
    d: "M49.88,149.537l-.08-7.027h3.824l.132,7.027Z",
    transform: "translate(-49.8 -142.51)",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6339",
    "data-name": "Group 6339",
    transform: "translate(0.044 1.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6338",
    "data-name": "Group 6338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6337",
    "data-name": "Group 6337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6336",
    "data-name": "Group 6336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6335",
    "data-name": "Group 6335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6334",
    "data-name": "Group 6334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11748",
    "data-name": "Path 11748",
    d: "M53.414,144.19a9.958,9.958,0,0,1-1.777.08,9.958,9.958,0,0,1-1.777-.08,9.958,9.958,0,0,1,1.777-.08A9.958,9.958,0,0,1,53.414,144.19Z",
    transform: "translate(-49.86 -144.11)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6345",
    "data-name": "Group 6345",
    transform: "translate(0.044 2.252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6344",
    "data-name": "Group 6344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6343",
    "data-name": "Group 6343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6342",
    "data-name": "Group 6342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6341",
    "data-name": "Group 6341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6340",
    "data-name": "Group 6340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11749",
    "data-name": "Path 11749",
    d: "M53.414,145.67a9.96,9.96,0,0,1-1.777.08,9.96,9.96,0,0,1-1.777-.08,9.961,9.961,0,0,1,1.777-.08A10.857,10.857,0,0,1,53.414,145.67Z",
    transform: "translate(-49.86 -145.59)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6351",
    "data-name": "Group 6351",
    transform: "translate(0.044 3.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6350",
    "data-name": "Group 6350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6349",
    "data-name": "Group 6349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6348",
    "data-name": "Group 6348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6347",
    "data-name": "Group 6347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6346",
    "data-name": "Group 6346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11750",
    "data-name": "Path 11750",
    d: "M53.414,147.16a9.956,9.956,0,0,1-1.777.08,9.956,9.956,0,0,1-1.777-.08,9.96,9.96,0,0,1,1.777-.08A9.96,9.96,0,0,1,53.414,147.16Z",
    transform: "translate(-49.86 -147.08)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6357",
    "data-name": "Group 6357",
    transform: "translate(0.044 4.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6356",
    "data-name": "Group 6356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6355",
    "data-name": "Group 6355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6354",
    "data-name": "Group 6354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6353",
    "data-name": "Group 6353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6352",
    "data-name": "Group 6352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11751",
    "data-name": "Path 11751",
    d: "M53.414,148.64a9.953,9.953,0,0,1-1.777.08,9.953,9.953,0,0,1-1.777-.08,9.959,9.959,0,0,1,1.777-.08A9.959,9.959,0,0,1,53.414,148.64Z",
    transform: "translate(-49.86 -148.56)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6363",
    "data-name": "Group 6363",
    transform: "translate(0.044 5.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6362",
    "data-name": "Group 6362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6361",
    "data-name": "Group 6361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6360",
    "data-name": "Group 6360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6359",
    "data-name": "Group 6359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6358",
    "data-name": "Group 6358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11752",
    "data-name": "Path 11752",
    d: "M53.414,150.12a9.959,9.959,0,0,1-1.777.08,9.959,9.959,0,0,1-1.777-.08,9.955,9.955,0,0,1,1.777-.08A9.955,9.955,0,0,1,53.414,150.12Z",
    transform: "translate(-49.86 -150.04)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6369",
    "data-name": "Group 6369",
    transform: "translate(0 0.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6368",
    "data-name": "Group 6368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6367",
    "data-name": "Group 6367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6366",
    "data-name": "Group 6366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6365",
    "data-name": "Group 6365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11753",
    "data-name": "Path 11753",
    d: "M49.52,142.26H91.9a19.9,19.9,0,0,1,0,7.59H49.7v-.519h2.581a1.223,1.223,0,0,0,1.221-1.221v-4.2a1.223,1.223,0,0,0-1.221-1.221H49.527v-.424Z",
    transform: "translate(-49.52 -142.26)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6394",
    "data-name": "Group 6394",
    transform: "translate(8.986 2.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6373",
    "data-name": "Group 6373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6372",
    "data-name": "Group 6372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6371",
    "data-name": "Group 6371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6370",
    "data-name": "Group 6370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11754",
    "data-name": "Path 11754",
    d: "M62.841,146.907h.709a.123.123,0,0,1,.073.022.139.139,0,0,1,.073.132.093.093,0,0,1-.007.044c-.015.058-.029.117-.051.183a2.007,2.007,0,0,1-.446.8.854.854,0,0,1-.6.314.356.356,0,0,1-.088-.007.7.7,0,0,1-.483-.351,1.6,1.6,0,0,1-.212-.848,2.518,2.518,0,0,1,.08-.607,2.019,2.019,0,0,1,.417-.819.841.841,0,0,1,.636-.336.692.692,0,0,1,.271.059.843.843,0,0,1,.409.519.12.12,0,0,1,.015.073.124.124,0,0,1-.022.073.139.139,0,0,1-.132.073.143.143,0,0,1-.051-.007.138.138,0,0,1-.1-.1l-.007-.015a.61.61,0,0,0-.088-.168.416.416,0,0,0-.336-.2.389.389,0,0,0-.234.088,1.3,1.3,0,0,0-.388.556,2.109,2.109,0,0,0-.168.8,1.459,1.459,0,0,0,.124.629.411.411,0,0,0,.366.278.53.53,0,0,0,.344-.2,1.886,1.886,0,0,0,.366-.658c-.329,0-.5,0-.5-.007-.11-.015-.168-.073-.168-.168a.106.106,0,0,1,.015-.051A.222.222,0,0,1,62.841,146.907Z",
    transform: "translate(-61.81 -145.43)",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6377",
    "data-name": "Group 6377",
    transform: "translate(1.923 0.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6376",
    "data-name": "Group 6376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6375",
    "data-name": "Group 6375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6374",
    "data-name": "Group 6374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11755",
    "data-name": "Path 11755",
    d: "M65.954,145.547a.357.357,0,0,1,.022.051c.029.1.2.98.5,2.625a.066.066,0,0,1,.007.037.167.167,0,0,1-.022.08.143.143,0,0,1-.124.08h-.022a.132.132,0,0,1-.117-.1l-.168-.87h-.87l-.417.877a.055.055,0,0,1-.015.029.155.155,0,0,1-.132.073.147.147,0,0,1-.08-.022.151.151,0,0,1-.073-.124.093.093,0,0,1,.007-.044q.044-.088.132-.285c.607-1.331.972-2.113,1.089-2.354a.185.185,0,0,1,.146-.11A.115.115,0,0,1,65.954,145.547Zm-.19.585-.468.994h.665Z",
    transform: "translate(-64.44 -145.484)",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6381",
    "data-name": "Group 6381",
    transform: "translate(4.372 0.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6380",
    "data-name": "Group 6380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6379",
    "data-name": "Group 6379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6378",
    "data-name": "Group 6378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11756",
    "data-name": "Path 11756",
    d: "M69.223,148.4h-1.28a.147.147,0,0,1-.08-.022.255.255,0,0,1-.073-.161h0c0-.051.117-.921.351-2.618,0-.022.007-.037.007-.058a.14.14,0,0,1,.139-.1.259.259,0,0,1,.073.015.146.146,0,0,1,.08.132c-.015.117-.037.351-.088.717-.146,1.119-.219,1.7-.227,1.769h1.082a.263.263,0,0,1,.08.015.14.14,0,0,1,.1.139.124.124,0,0,1-.007.051A.158.158,0,0,1,69.223,148.4Z",
    transform: "translate(-67.79 -145.45)",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6385",
    "data-name": "Group 6385",
    transform: "translate(6.032 0.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6384",
    "data-name": "Group 6384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6383",
    "data-name": "Group 6383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6382",
    "data-name": "Group 6382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11757",
    "data-name": "Path 11757",
    d: "M71.574,145.547a.357.357,0,0,1,.022.051c.029.1.2.98.5,2.625a.066.066,0,0,1,.007.037.167.167,0,0,1-.022.08.143.143,0,0,1-.124.08h-.022a.132.132,0,0,1-.117-.1l-.168-.87h-.87l-.417.877a.055.055,0,0,1-.015.029.155.155,0,0,1-.132.073.147.147,0,0,1-.08-.022.151.151,0,0,1-.073-.124.093.093,0,0,1,.007-.044q.044-.088.132-.285c.607-1.331.972-2.113,1.089-2.354a.185.185,0,0,1,.146-.11A.115.115,0,0,1,71.574,145.547Zm-.19.585-.468.994h.665Z",
    transform: "translate(-70.06 -145.484)",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6389",
    "data-name": "Group 6389",
    transform: "translate(8.372 0.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6388",
    "data-name": "Group 6388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6387",
    "data-name": "Group 6387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6386",
    "data-name": "Group 6386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11758",
    "data-name": "Path 11758",
    d: "M74.474,147.055c.1.278.175.49.234.643.132.366.2.556.2.578a.167.167,0,0,1-.022.08.151.151,0,0,1-.124.073.13.13,0,0,1-.124-.1.338.338,0,0,0-.022-.066c-.073-.161-.183-.461-.344-.9l-.724.987a.187.187,0,0,1-.132.08.166.166,0,0,1-.08-.022.136.136,0,0,1-.073-.124v-.029a.5.5,0,0,1,.073-.124c.241-.314.512-.687.8-1.119q-.044-.132-.088-.241c-.271-.731-.409-1.1-.409-1.126a.167.167,0,0,1,.022-.08.129.129,0,0,1,.124-.073.137.137,0,0,1,.139.088l.424,1.148.855-1.163a.177.177,0,0,1,.139-.073.26.26,0,0,1,.073.015.143.143,0,0,1,.073.139.322.322,0,0,1-.015.073Z",
    transform: "translate(-73.26 -145.49)",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6393",
    "data-name": "Group 6393",
    transform: "translate(10.558 0.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6392",
    "data-name": "Group 6392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6391",
    "data-name": "Group 6391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6390",
    "data-name": "Group 6390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11759",
    "data-name": "Path 11759",
    d: "M78.436,145.48a.321.321,0,0,1,.073.015.146.146,0,0,1,.08.132c-.212,1.652-.322,2.544-.344,2.676a1.707,1.707,0,0,1-.271.695,1,1,0,0,1-.848.417.981.981,0,0,1-.409-.11.942.942,0,0,1-.453-.395.12.12,0,0,1-.015-.073.124.124,0,0,1,.022-.073.146.146,0,0,1,.249-.007.818.818,0,0,0,.651.373.637.637,0,0,0,.5-.256,1.427,1.427,0,0,0,.285-.8.613.613,0,0,1-.19.2.759.759,0,0,1-.461.154.357.357,0,0,1-.088-.007.675.675,0,0,1-.483-.351,1.6,1.6,0,0,1-.212-.848q0-.23.022-.483a10.777,10.777,0,0,1,.175-1.1.1.1,0,0,1,.015-.044.138.138,0,0,1,.139-.1.141.141,0,0,1,.073.022.136.136,0,0,1,.073.124,4.836,4.836,0,0,1-.073.585,8.455,8.455,0,0,0-.1.892,1.721,1.721,0,0,0,.117.695c.088.2.212.314.38.314a.125.125,0,0,0,.051-.007.667.667,0,0,0,.38-.307,1.915,1.915,0,0,0,.314-.7l.2-1.455a.118.118,0,0,1,.022-.066A.116.116,0,0,1,78.436,145.48Z",
    transform: "translate(-76.25 -145.48)",
    fill: "#fafafa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6400",
    "data-name": "Group 6400",
    transform: "translate(40.704)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6399",
    "data-name": "Group 6399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6398",
    "data-name": "Group 6398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6397",
    "data-name": "Group 6397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6396",
    "data-name": "Group 6396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6395",
    "data-name": "Group 6395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11760",
    "data-name": "Path 11760",
    d: "M105.27,149.914c-.044,0-.08-1.747-.08-3.9s.037-3.9.08-3.9.08,1.74.08,3.9S105.314,149.914,105.27,149.914Z",
    transform: "translate(-105.19 -142.12)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6406",
    "data-name": "Group 6406",
    transform: "translate(6.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6405",
    "data-name": "Group 6405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6404",
    "data-name": "Group 6404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6403",
    "data-name": "Group 6403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6402",
    "data-name": "Group 6402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6401",
    "data-name": "Group 6401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11761",
    "data-name": "Path 11761",
    d: "M57.84,149.914c-.044,0-.08-1.747-.08-3.9s.037-3.9.08-3.9.08,1.74.08,3.9S57.884,149.914,57.84,149.914Z",
    transform: "translate(-57.76 -142.12)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6412",
    "data-name": "Group 6412",
    transform: "translate(41.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6411",
    "data-name": "Group 6411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6410",
    "data-name": "Group 6410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6409",
    "data-name": "Group 6409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6408",
    "data-name": "Group 6408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6407",
    "data-name": "Group 6407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11762",
    "data-name": "Path 11762",
    d: "M106.29,149.914c-.044,0-.08-1.747-.08-3.9s.037-3.9.08-3.9.08,1.74.08,3.9S106.334,149.914,106.29,149.914Z",
    transform: "translate(-106.21 -142.12)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6418",
    "data-name": "Group 6418",
    transform: "translate(5.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6417",
    "data-name": "Group 6417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6416",
    "data-name": "Group 6416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6415",
    "data-name": "Group 6415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6414",
    "data-name": "Group 6414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6413",
    "data-name": "Group 6413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11763",
    "data-name": "Path 11763",
    d: "M56.89,149.914c-.044,0-.08-1.747-.08-3.9s.037-3.9.08-3.9.08,1.74.08,3.9S56.934,149.914,56.89,149.914Z",
    transform: "translate(-56.81 -142.12)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6481",
    "data-name": "Group 6481",
    transform: "translate(25.54 1.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6429",
    "data-name": "Group 6429",
    transform: "translate(0.3 0.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6428",
    "data-name": "Group 6428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6427",
    "data-name": "Group 6427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6426",
    "data-name": "Group 6426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6425",
    "data-name": "Group 6425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6424",
    "data-name": "Group 6424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6423",
    "data-name": "Group 6423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6422",
    "data-name": "Group 6422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6421",
    "data-name": "Group 6421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6420",
    "data-name": "Group 6420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11764",
    "data-name": "Path 11764",
    d: "M89.532,143.875l-.007-.015c1.155.936,2.727,2.2,4.482,3.612l.037.029-.051.015c-.19.051-.395.1-.592.154-1.36.358-2.647.695-3.78.994h-.015c-1.4-.6-2.588-1.1-3.429-1.455-.417-.175-.746-.322-.972-.417-.11-.051-.2-.088-.256-.11-.029-.015-.051-.022-.066-.029s-.022-.007-.022-.015a.057.057,0,0,1,.022.007c.015.007.037.015.066.029.059.022.146.059.256.1.227.1.556.234.972.4.841.351,2.025.848,3.437,1.433H89.6c1.133-.3,2.42-.636,3.78-.994.2-.051.409-.11.6-.154l-.007.044c-1.748-1.418-3.312-2.691-4.467-3.627l-.007-.007v-.007",
    transform: "translate(-84.86 -143.86)",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6438",
    "data-name": "Group 6438",
    transform: "translate(8.708 3.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6437",
    "data-name": "Group 6437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6436",
    "data-name": "Group 6436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6435",
    "data-name": "Group 6435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6434",
    "data-name": "Group 6434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6433",
    "data-name": "Group 6433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6432",
    "data-name": "Group 6432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6431",
    "data-name": "Group 6431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6430",
    "data-name": "Group 6430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11765",
    "data-name": "Path 11765",
    d: "M96.689,148.03l.249.234.322-.073-.139.3.168.292-.336-.044-.219.249-.066-.329-.307-.132.3-.161Z",
    transform: "translate(-96.36 -148.03)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6447",
    "data-name": "Group 6447",
    transform: "translate(4.548 4.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6446",
    "data-name": "Group 6446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6445",
    "data-name": "Group 6445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6444",
    "data-name": "Group 6444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6443",
    "data-name": "Group 6443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6442",
    "data-name": "Group 6442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6441",
    "data-name": "Group 6441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6440",
    "data-name": "Group 6440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6439",
    "data-name": "Group 6439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11766",
    "data-name": "Path 11766",
    d: "M90.867,149.98l.161.139.212-.058-.08.2.117.183-.212-.015-.139.168-.051-.2-.2-.08.183-.11Z",
    transform: "translate(-90.67 -149.98)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6456",
    "data-name": "Group 6456",
    transform: "translate(0 2.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6455",
    "data-name": "Group 6455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6454",
    "data-name": "Group 6454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6453",
    "data-name": "Group 6453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6452",
    "data-name": "Group 6452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6451",
    "data-name": "Group 6451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6450",
    "data-name": "Group 6450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6449",
    "data-name": "Group 6449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6448",
    "data-name": "Group 6448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11767",
    "data-name": "Path 11767",
    d: "M84.45,147.247l.263.015.161-.212.066.256.256.1-.227.146-.007.263-.212-.168-.256.073.1-.249Z",
    transform: "translate(-84.45 -147.05)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6465",
    "data-name": "Group 6465",
    transform: "translate(11.048 0.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6464",
    "data-name": "Group 6464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6463",
    "data-name": "Group 6463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6462",
    "data-name": "Group 6462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6461",
    "data-name": "Group 6461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6460",
    "data-name": "Group 6460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6459",
    "data-name": "Group 6459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6458",
    "data-name": "Group 6458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6457",
    "data-name": "Group 6457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11768",
    "data-name": "Path 11768",
    d: "M99.56,143.88l.263.022.168-.212.066.256.249.1-.227.139-.007.271-.2-.168-.256.073.1-.249Z",
    transform: "translate(-99.56 -143.69)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6474",
    "data-name": "Group 6474",
    transform: "translate(4.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6473",
    "data-name": "Group 6473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6472",
    "data-name": "Group 6472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6471",
    "data-name": "Group 6471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6470",
    "data-name": "Group 6470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6469",
    "data-name": "Group 6469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6468",
    "data-name": "Group 6468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6467",
    "data-name": "Group 6467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6466",
    "data-name": "Group 6466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11769",
    "data-name": "Path 11769",
    d: "M90.95,143.674l.168.007.11-.132.044.161.154.059-.139.1-.007.168-.132-.11-.161.044.058-.154Z",
    transform: "translate(-90.95 -143.55)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6480",
    "data-name": "Group 6480",
    transform: "translate(4.95 0.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6479",
    "data-name": "Group 6479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6478",
    "data-name": "Group 6478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6477",
    "data-name": "Group 6477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6476",
    "data-name": "Group 6476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6475",
    "data-name": "Group 6475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11770",
    "data-name": "Path 11770",
    d: "M97.691,144.107c0,.015-1.448-.029-3.239-.11s-3.232-.154-3.232-.168,1.448.029,3.239.11S97.691,144.092,97.691,144.107Z",
    transform: "translate(-91.22 -143.826)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6517",
    "data-name": "Group 6517",
    transform: "translate(2.028 8.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6487",
    "data-name": "Group 6487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6486",
    "data-name": "Group 6486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6485",
    "data-name": "Group 6485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6484",
    "data-name": "Group 6484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6483",
    "data-name": "Group 6483"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11771",
    "data-name": "Path 11771",
    d: "M86.313,140.855H43.335a3.6,3.6,0,0,1,0-3.575H86.313A4.11,4.11,0,0,1,86.313,140.855Z",
    transform: "translate(-42.859 -137.28)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6492",
    "data-name": "Group 6492",
    transform: "translate(9.374 1.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6491",
    "data-name": "Group 6491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6490",
    "data-name": "Group 6490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6489",
    "data-name": "Group 6489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6488",
    "data-name": "Group 6488"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_688",
    "data-name": "Rectangle 688",
    width: 23.288,
    height: 1.301,
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6498",
    "data-name": "Group 6498",
    transform: "translate(1.386 0.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6497",
    "data-name": "Group 6497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6496",
    "data-name": "Group 6496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6495",
    "data-name": "Group 6495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6494",
    "data-name": "Group 6494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6493",
    "data-name": "Group 6493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11772",
    "data-name": "Path 11772",
    d: "M45.5,140.9c-.015.015-.168-.139-.336-.431a3.146,3.146,0,0,1-.395-1.272,3.032,3.032,0,0,1,.168-1.316,1.169,1.169,0,0,1,.256-.483,4.31,4.31,0,0,1-.154.519,3.673,3.673,0,0,0-.117,1.272,3.625,3.625,0,0,0,.336,1.236A4.277,4.277,0,0,1,45.5,140.9Z",
    transform: "translate(-44.754 -137.399)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6504",
    "data-name": "Group 6504",
    transform: "translate(2.314 0.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6503",
    "data-name": "Group 6503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6502",
    "data-name": "Group 6502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6501",
    "data-name": "Group 6501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6500",
    "data-name": "Group 6500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6499",
    "data-name": "Group 6499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11773",
    "data-name": "Path 11773",
    d: "M46.767,140.9c-.015.015-.168-.139-.336-.431a3.146,3.146,0,0,1-.395-1.272,3.032,3.032,0,0,1,.168-1.316,1.169,1.169,0,0,1,.256-.483,4.307,4.307,0,0,1-.154.519,3.673,3.673,0,0,0-.117,1.272,3.625,3.625,0,0,0,.336,1.236A4.276,4.276,0,0,1,46.767,140.9Z",
    transform: "translate(-46.024 -137.399)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6510",
    "data-name": "Group 6510",
    transform: "translate(41.717 0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6509",
    "data-name": "Group 6509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6508",
    "data-name": "Group 6508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6507",
    "data-name": "Group 6507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6506",
    "data-name": "Group 6506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6505",
    "data-name": "Group 6505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11774",
    "data-name": "Path 11774",
    d: "M99.919,140.792a6.837,6.837,0,0,0,.3-1.748,7.034,7.034,0,0,0-.285-1.755,3.1,3.1,0,0,1,.439,1.755A3.206,3.206,0,0,1,99.919,140.792Z",
    transform: "translate(-99.915 -137.289)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6516",
    "data-name": "Group 6516",
    transform: "translate(40.908 0.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6515",
    "data-name": "Group 6515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6514",
    "data-name": "Group 6514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6513",
    "data-name": "Group 6513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6512",
    "data-name": "Group 6512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6511",
    "data-name": "Group 6511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11775",
    "data-name": "Path 11775",
    d: "M98.817,140.812c-.044-.007.132-.768.132-1.711s-.183-1.7-.132-1.711a5.151,5.151,0,0,1,0,3.422Z",
    transform: "translate(-98.808 -137.39)",
    fill: "#f5f5f5"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6559",
    "data-name": "Group 6559",
    transform: "translate(61.055 18.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6538",
    "data-name": "Group 6538",
    transform: "translate(9.545 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6524",
    "data-name": "Group 6524",
    transform: "translate(0.115 0.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6523",
    "data-name": "Group 6523",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6522",
    "data-name": "Group 6522",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6521",
    "data-name": "Group 6521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6520",
    "data-name": "Group 6520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6519",
    "data-name": "Group 6519"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689",
    width: 15.303,
    height: 16.232,
    transform: "translate(0 0.082) rotate(-0.307)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6530",
    "data-name": "Group 6530",
    transform: "translate(15.345 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6529",
    "data-name": "Group 6529",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6528",
    "data-name": "Group 6528",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6527",
    "data-name": "Group 6527",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6526",
    "data-name": "Group 6526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6525",
    "data-name": "Group 6525"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_690",
    "data-name": "Rectangle 690",
    width: 15.303,
    height: 16.232,
    transform: "translate(0 0.082) rotate(-0.307)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6537",
    "data-name": "Group 6537",
    transform: "translate(0 4.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6536",
    "data-name": "Group 6536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6535",
    "data-name": "Group 6535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6534",
    "data-name": "Group 6534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6533",
    "data-name": "Group 6533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6532",
    "data-name": "Group 6532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6531",
    "data-name": "Group 6531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11776",
    "data-name": "Path 11776",
    d: "M129.961,75.342q15.256.121,30.534-.139a.161.161,0,0,0,0-.322q-15.256-.088-30.534.19a.135.135,0,0,0,0,.271Z",
    transform: "translate(-129.826 -74.859)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6558",
    "data-name": "Group 6558",
    transform: "translate(0 15.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6544",
    "data-name": "Group 6544",
    transform: "translate(0.118 0.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6543",
    "data-name": "Group 6543",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6542",
    "data-name": "Group 6542",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6541",
    "data-name": "Group 6541",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6540",
    "data-name": "Group 6540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6539",
    "data-name": "Group 6539"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_691",
    "data-name": "Rectangle 691",
    width: 27.807,
    height: 13.227,
    transform: "translate(0 0.149) rotate(-0.307)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6550",
    "data-name": "Group 6550",
    transform: "translate(27.793 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6549",
    "data-name": "Group 6549",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6548",
    "data-name": "Group 6548",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6547",
    "data-name": "Group 6547",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6546",
    "data-name": "Group 6546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6545",
    "data-name": "Group 6545"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_692",
    "data-name": "Rectangle 692",
    width: 27.807,
    height: 13.227,
    transform: "translate(0 0.149) rotate(-0.307)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6557",
    "data-name": "Group 6557",
    transform: "translate(0 3.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6556",
    "data-name": "Group 6556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6555",
    "data-name": "Group 6555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6554",
    "data-name": "Group 6554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6553",
    "data-name": "Group 6553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6552",
    "data-name": "Group 6552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6551",
    "data-name": "Group 6551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11777",
    "data-name": "Path 11777",
    d: "M116.91,96.114c18.469.212,37,.022,55.481-.271a.161.161,0,0,0,0-.322c-18.469-.1-37.012-.088-55.481.322a.135.135,0,1,0,0,.271Z",
    transform: "translate(-116.772 -95.472)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6580",
    "data-name": "Group 6580",
    transform: "translate(35.954 109.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6579",
    "data-name": "Group 6579",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6565",
    "data-name": "Group 6565",
    transform: "translate(0.117 0.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6564",
    "data-name": "Group 6564",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6563",
    "data-name": "Group 6563",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6562",
    "data-name": "Group 6562",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6561",
    "data-name": "Group 6561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6560",
    "data-name": "Group 6560"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    width: 27.807,
    height: 13.227,
    transform: "translate(0 0.149) rotate(-0.307)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6571",
    "data-name": "Group 6571",
    transform: "translate(27.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6570",
    "data-name": "Group 6570",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6569",
    "data-name": "Group 6569",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6568",
    "data-name": "Group 6568",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6567",
    "data-name": "Group 6567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6566",
    "data-name": "Group 6566"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    width: 27.807,
    height: 13.227,
    transform: "translate(0 0.149) rotate(-0.307)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6578",
    "data-name": "Group 6578",
    transform: "translate(0 3.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6577",
    "data-name": "Group 6577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6576",
    "data-name": "Group 6576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6575",
    "data-name": "Group 6575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6574",
    "data-name": "Group 6574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6573",
    "data-name": "Group 6573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6572",
    "data-name": "Group 6572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11778",
    "data-name": "Path 11778",
    d: "M82.58,198.524c18.469.212,37,.022,55.481-.271a.161.161,0,0,0,0-.322c-18.469-.1-37.012-.088-55.481.322a.135.135,0,1,0,0,.271Z",
    transform: "translate(-82.442 -197.882)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6646",
    "data-name": "Group 6646",
    transform: "translate(19.539 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6586",
    "data-name": "Group 6586",
    transform: "translate(0 13.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6585",
    "data-name": "Group 6585",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6584",
    "data-name": "Group 6584",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6583",
    "data-name": "Group 6583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6582",
    "data-name": "Group 6582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6581",
    "data-name": "Group 6581"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_695",
    "data-name": "Rectangle 695",
    width: 7.012,
    height: 34.899,
    transform: "translate(0 0.038) rotate(-0.307)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6592",
    "data-name": "Group 6592",
    transform: "translate(6.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6591",
    "data-name": "Group 6591",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6590",
    "data-name": "Group 6590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6589",
    "data-name": "Group 6589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6588",
    "data-name": "Group 6588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6587",
    "data-name": "Group 6587"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_696",
    "data-name": "Rectangle 696",
    width: 7.012,
    height: 48.001,
    transform: "translate(0 0.038) rotate(-0.308)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6629",
    "data-name": "Group 6629",
    transform: "translate(13.853 8.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6598",
    "data-name": "Group 6598",
    transform: "translate(0.072 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6597",
    "data-name": "Group 6597",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6596",
    "data-name": "Group 6596",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6595",
    "data-name": "Group 6595",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6594",
    "data-name": "Group 6594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6593",
    "data-name": "Group 6593"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_697",
    "data-name": "Rectangle 697",
    width: 10.902,
    height: 38.898,
    transform: "translate(0 0.059) rotate(-0.308)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6604",
    "data-name": "Group 6604",
    transform: "translate(0 7.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6603",
    "data-name": "Group 6603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6602",
    "data-name": "Group 6602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6601",
    "data-name": "Group 6601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6600",
    "data-name": "Group 6600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6599",
    "data-name": "Group 6599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11779",
    "data-name": "Path 11779",
    d: "M89.834,66.33a39.723,39.723,0,0,1-5.447.19,39.635,39.635,0,0,1-5.447-.19,39.721,39.721,0,0,1,5.447-.19A38.371,38.371,0,0,1,89.834,66.33Z",
    transform: "translate(-78.94 -66.14)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6610",
    "data-name": "Group 6610",
    transform: "translate(0 5.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6609",
    "data-name": "Group 6609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6608",
    "data-name": "Group 6608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6607",
    "data-name": "Group 6607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6606",
    "data-name": "Group 6606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6605",
    "data-name": "Group 6605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11780",
    "data-name": "Path 11780",
    d: "M89.834,64.09a39.725,39.725,0,0,1-5.447.19,39.636,39.636,0,0,1-5.447-.19,39.72,39.72,0,0,1,5.447-.19A39.719,39.719,0,0,1,89.834,64.09Z",
    transform: "translate(-78.94 -63.9)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6616",
    "data-name": "Group 6616",
    transform: "translate(0 32.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6615",
    "data-name": "Group 6615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6614",
    "data-name": "Group 6614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6613",
    "data-name": "Group 6613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6612",
    "data-name": "Group 6612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6611",
    "data-name": "Group 6611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11781",
    "data-name": "Path 11781",
    d: "M89.834,101.27a39.723,39.723,0,0,1-5.447.19,39.635,39.635,0,0,1-5.447-.19,39.723,39.723,0,0,1,5.447-.19A39.724,39.724,0,0,1,89.834,101.27Z",
    transform: "translate(-78.94 -101.08)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6622",
    "data-name": "Group 6622",
    transform: "translate(0 31.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6621",
    "data-name": "Group 6621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6620",
    "data-name": "Group 6620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6619",
    "data-name": "Group 6619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6618",
    "data-name": "Group 6618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6617",
    "data-name": "Group 6617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11782",
    "data-name": "Path 11782",
    d: "M89.834,99.04a39.723,39.723,0,0,1-5.447.19,39.635,39.635,0,0,1-5.447-.19,39.72,39.72,0,0,1,5.447-.19A39.72,39.72,0,0,1,89.834,99.04Z",
    transform: "translate(-78.94 -98.85)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6628",
    "data-name": "Group 6628",
    transform: "translate(5.433 10.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6627",
    "data-name": "Group 6627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6626",
    "data-name": "Group 6626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6625",
    "data-name": "Group 6625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6624",
    "data-name": "Group 6624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6623",
    "data-name": "Group 6623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11783",
    "data-name": "Path 11783",
    d: "M86.56,87.784c-.1,0-.19-3.926-.19-8.767s.088-8.767.19-8.767.19,3.926.19,8.767S86.662,87.784,86.56,87.784Z",
    transform: "translate(-86.37 -70.25)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6635",
    "data-name": "Group 6635",
    transform: "translate(24.865 18.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6634",
    "data-name": "Group 6634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6633",
    "data-name": "Group 6633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6632",
    "data-name": "Group 6632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6631",
    "data-name": "Group 6631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6630",
    "data-name": "Group 6630"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_698",
    "data-name": "Rectangle 698",
    width: 11.86,
    height: 29.364,
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6640",
    "data-name": "Group 6640",
    transform: "translate(8.23 6.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6639",
    "data-name": "Group 6639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6638",
    "data-name": "Group 6638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6637",
    "data-name": "Group 6637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6636",
    "data-name": "Group 6636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11784",
    "data-name": "Path 11784",
    d: "M75.286,54.388a2.018,2.018,0,1,1-2.018-2.018A2.017,2.017,0,0,1,75.286,54.388Z",
    transform: "translate(-71.25 -52.37)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6645",
    "data-name": "Group 6645",
    transform: "translate(9.627 13.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6644",
    "data-name": "Group 6644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6643",
    "data-name": "Group 6643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6642",
    "data-name": "Group 6642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6641",
    "data-name": "Group 6641"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_699",
    "data-name": "Rectangle 699",
    width: 1.243,
    height: 28.552,
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6652",
    "data-name": "Group 6652",
    transform: "translate(0 48.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6647",
    "data-name": "Group 6647",
    transform: "translate(0 40.068)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_700",
    "data-name": "Rectangle 700",
    width: 123.488,
    height: 4.226,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6648",
    "data-name": "Group 6648"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    width: 123.488,
    height: 4.226,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6649",
    "data-name": "Group 6649",
    transform: "translate(25.204 74.74)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_702",
    "data-name": "Rectangle 702",
    width: 98.284,
    height: 3.985,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6650",
    "data-name": "Group 6650",
    transform: "translate(57.032 3.393)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    width: 4.709,
    height: 39.864,
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6651",
    "data-name": "Group 6651",
    transform: "translate(25.225 40.068)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    width: 4.709,
    height: 38.642,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6654",
    "data-name": "Group 6654",
    transform: "translate(72.293 69.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6653",
    "data-name": "Group 6653",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11785",
    "data-name": "Path 11785",
    d: "M145.17,139.647l-2.9,4.16s6.515,1.806,6.515,7.6-3.978,6.873-8.321,6.873-8.5-1.265-8.321-7.056,5.608-7.962,5.608-7.962l-2.713-3.619H145.17Z",
    transform: "translate(-132.142 -139.64)",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6787",
    "data-name": "Group 6787",
    transform: "translate(150.929 190.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6725",
    "data-name": "Group 6725",
    transform: "translate(0 28.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6724",
    "data-name": "Group 6724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6660",
    "data-name": "Group 6660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6659",
    "data-name": "Group 6659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6658",
    "data-name": "Group 6658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6657",
    "data-name": "Group 6657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6656",
    "data-name": "Group 6656"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_705",
    "data-name": "Rectangle 705",
    width: 130.719,
    height: 60.285,
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6665",
    "data-name": "Group 6665",
    transform: "translate(2.99 3.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6664",
    "data-name": "Group 6664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6663",
    "data-name": "Group 6663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6662",
    "data-name": "Group 6662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6661",
    "data-name": "Group 6661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11786",
    "data-name": "Path 11786",
    d: "M368.394,401.985H243.78V347.71H368.394Zm-123.8-.812H367.582V348.529H244.592Z",
    transform: "translate(-243.78 -347.71)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6670",
    "data-name": "Group 6670",
    transform: "translate(130.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6669",
    "data-name": "Group 6669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6668",
    "data-name": "Group 6668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6667",
    "data-name": "Group 6667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6666",
    "data-name": "Group 6666"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 31.938,
    height: 60.285,
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6676",
    "data-name": "Group 6676",
    transform: "translate(3.239 19.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6675",
    "data-name": "Group 6675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6674",
    "data-name": "Group 6674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6673",
    "data-name": "Group 6673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6672",
    "data-name": "Group 6672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6671",
    "data-name": "Group 6671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11787",
    "data-name": "Path 11787",
    d: "M244.274,370.569h123.8a.165.165,0,0,0,0-.329h-123.8a.165.165,0,0,0,0,.329Z",
    transform: "translate(-244.12 -370.24)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6682",
    "data-name": "Group 6682",
    transform: "translate(65.186 3.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6681",
    "data-name": "Group 6681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6680",
    "data-name": "Group 6680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6679",
    "data-name": "Group 6679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6678",
    "data-name": "Group 6678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6677",
    "data-name": "Group 6677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11788",
    "data-name": "Path 11788",
    d: "M329.36,364.38A135.994,135.994,0,0,0,329.4,348a.168.168,0,0,0-.336,0,135.994,135.994,0,0,0,.044,16.378.124.124,0,0,0,.249,0Z",
    transform: "translate(-328.842 -347.842)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6687",
    "data-name": "Group 6687",
    transform: "translate(95.645 9.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6686",
    "data-name": "Group 6686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6685",
    "data-name": "Group 6685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6684",
    "data-name": "Group 6684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6683",
    "data-name": "Group 6683"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11789",
    "data-name": "Path 11789",
    d: "M373.878,358.649a1.689,1.689,0,1,1-1.689-1.689A1.69,1.69,0,0,1,373.878,358.649Z",
    transform: "translate(-370.5 -356.96)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6692",
    "data-name": "Group 6692",
    transform: "translate(30.673 9.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6691",
    "data-name": "Group 6691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6690",
    "data-name": "Group 6690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6689",
    "data-name": "Group 6689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6688",
    "data-name": "Group 6688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11790",
    "data-name": "Path 11790",
    d: "M285.018,358.649a1.689,1.689,0,1,1-1.689-1.689A1.69,1.69,0,0,1,285.018,358.649Z",
    transform: "translate(-281.64 -356.96)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6697",
    "data-name": "Group 6697",
    transform: "translate(63.605 28.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6696",
    "data-name": "Group 6696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6695",
    "data-name": "Group 6695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6694",
    "data-name": "Group 6694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6693",
    "data-name": "Group 6693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11791",
    "data-name": "Path 11791",
    d: "M330.058,384.209a1.689,1.689,0,1,1-1.689-1.689A1.69,1.69,0,0,1,330.058,384.209Z",
    transform: "translate(-326.68 -382.52)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6702",
    "data-name": "Group 6702",
    transform: "translate(8.898 60.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6701",
    "data-name": "Group 6701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6700",
    "data-name": "Group 6700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6699",
    "data-name": "Group 6699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6698",
    "data-name": "Group 6698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11792",
    "data-name": "Path 11792",
    d: "M258.587,425.83l-6.727,37.853h3.78l12.415-37.853Z",
    transform: "translate(-251.86 -425.83)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6707",
    "data-name": "Group 6707",
    transform: "translate(112.001 60.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6706",
    "data-name": "Group 6706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6705",
    "data-name": "Group 6705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6704",
    "data-name": "Group 6704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6703",
    "data-name": "Group 6703"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11793",
    "data-name": "Path 11793",
    d: "M402.339,425.83l5.63,37.911h-3.787L392.87,425.83Z",
    transform: "translate(-392.87 -425.83)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6712",
    "data-name": "Group 6712",
    transform: "translate(137.278 60.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6711",
    "data-name": "Group 6711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6710",
    "data-name": "Group 6710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6709",
    "data-name": "Group 6709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6708",
    "data-name": "Group 6708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11794",
    "data-name": "Path 11794",
    d: "M436.9,425.83l6.376,37.911H439.49L427.44,425.83Z",
    transform: "translate(-427.44 -425.83)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6717",
    "data-name": "Group 6717",
    transform: "translate(63.495 45.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6716",
    "data-name": "Group 6716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6715",
    "data-name": "Group 6715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6714",
    "data-name": "Group 6714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6713",
    "data-name": "Group 6713"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11795",
    "data-name": "Path 11795",
    d: "M329.908,407.549a1.689,1.689,0,1,1-1.689-1.689A1.69,1.69,0,0,1,329.908,407.549Z",
    transform: "translate(-326.53 -405.86)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6723",
    "data-name": "Group 6723",
    transform: "translate(3.239 38.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6722",
    "data-name": "Group 6722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6721",
    "data-name": "Group 6721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6720",
    "data-name": "Group 6720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6719",
    "data-name": "Group 6719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6718",
    "data-name": "Group 6718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11796",
    "data-name": "Path 11796",
    d: "M244.274,396.1h123.8a.165.165,0,0,0,0-.329h-123.8a.165.165,0,0,0,0,.329Z",
    transform: "translate(-244.12 -395.77)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6786",
    "data-name": "Group 6786",
    transform: "translate(51.691 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6731",
    "data-name": "Group 6731",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6730",
    "data-name": "Group 6730",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6729",
    "data-name": "Group 6729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6728",
    "data-name": "Group 6728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6727",
    "data-name": "Group 6727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6726",
    "data-name": "Group 6726"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    width: 8.043,
    height: 39.527,
    transform: "translate(39.527 0) rotate(89.697)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6768",
    "data-name": "Group 6768",
    transform: "translate(0.197 15.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6737",
    "data-name": "Group 6737",
    transform: "translate(0 0.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6736",
    "data-name": "Group 6736",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6735",
    "data-name": "Group 6735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6734",
    "data-name": "Group 6734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6733",
    "data-name": "Group 6733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6732",
    "data-name": "Group 6732"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    width: 12.503,
    height: 44.053,
    transform: "translate(44.053 0) rotate(89.697)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6743",
    "data-name": "Group 6743",
    transform: "translate(35.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6742",
    "data-name": "Group 6742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6741",
    "data-name": "Group 6741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6740",
    "data-name": "Group 6740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6739",
    "data-name": "Group 6739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6738",
    "data-name": "Group 6738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11797",
    "data-name": "Path 11797",
    d: "M359.322,338.433a92.25,92.25,0,0,1,0-12.5,92.263,92.263,0,0,1,0,12.5Z",
    transform: "translate(-359.11 -325.93)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6749",
    "data-name": "Group 6749",
    transform: "translate(37.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6748",
    "data-name": "Group 6748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6747",
    "data-name": "Group 6747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6746",
    "data-name": "Group 6746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6745",
    "data-name": "Group 6745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6744",
    "data-name": "Group 6744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11798",
    "data-name": "Path 11798",
    d: "M361.852,338.433a92.277,92.277,0,0,1,0-12.5,92.263,92.263,0,0,1,0,12.5Z",
    transform: "translate(-361.64 -325.93)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6755",
    "data-name": "Group 6755",
    transform: "translate(6.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6754",
    "data-name": "Group 6754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6753",
    "data-name": "Group 6753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6752",
    "data-name": "Group 6752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6751",
    "data-name": "Group 6751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6750",
    "data-name": "Group 6750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11799",
    "data-name": "Path 11799",
    d: "M319.742,338.433a92.25,92.25,0,0,1,0-12.5,92.263,92.263,0,0,1,0,12.5Z",
    transform: "translate(-319.53 -325.93)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6761",
    "data-name": "Group 6761",
    transform: "translate(8.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6760",
    "data-name": "Group 6760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6759",
    "data-name": "Group 6759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6758",
    "data-name": "Group 6758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6757",
    "data-name": "Group 6757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6756",
    "data-name": "Group 6756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11800",
    "data-name": "Path 11800",
    d: "M322.272,338.433a92.25,92.25,0,0,1,0-12.5,92.263,92.263,0,0,1,0,12.5Z",
    transform: "translate(-322.06 -325.93)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6767",
    "data-name": "Group 6767",
    transform: "translate(12.587 6.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6766",
    "data-name": "Group 6766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6765",
    "data-name": "Group 6765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6764",
    "data-name": "Group 6764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6763",
    "data-name": "Group 6763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6762",
    "data-name": "Group 6762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11801",
    "data-name": "Path 11801",
    d: "M327.87,334.679c0-.117,4.446-.219,9.922-.219s9.929.1,9.929.219-4.446.219-9.929.219S327.87,334.8,327.87,334.679Z",
    transform: "translate(-327.87 -334.46)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6785",
    "data-name": "Group 6785",
    transform: "translate(6.46 7.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6774",
    "data-name": "Group 6774",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6773",
    "data-name": "Group 6773",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6772",
    "data-name": "Group 6772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6771",
    "data-name": "Group 6771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6770",
    "data-name": "Group 6770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6769",
    "data-name": "Group 6769"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    width: 8.043,
    height: 54.355,
    transform: "translate(54.355 0) rotate(89.698)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6779",
    "data-name": "Group 6779",
    transform: "translate(44.053 1.843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6778",
    "data-name": "Group 6778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6777",
    "data-name": "Group 6777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6776",
    "data-name": "Group 6776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6775",
    "data-name": "Group 6775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11802",
    "data-name": "Path 11802",
    d: "M382.036,322.676a2.6,2.6,0,1,1,2.566-2.6A2.582,2.582,0,0,1,382.036,322.676Z",
    transform: "translate(-379.47 -317.47)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6784",
    "data-name": "Group 6784",
    transform: "translate(3.164 3.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6783",
    "data-name": "Group 6783",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6782",
    "data-name": "Group 6782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6781",
    "data-name": "Group 6781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6780",
    "data-name": "Group 6780"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    width: 1.609,
    height: 36.391,
    transform: "translate(36.391) rotate(90)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6872",
    "data-name": "Group 6872",
    transform: "translate(216.881 81.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6795",
    "data-name": "Group 6795",
    transform: "translate(4.212 0.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6794",
    "data-name": "Group 6794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6793",
    "data-name": "Group 6793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6792",
    "data-name": "Group 6792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6791",
    "data-name": "Group 6791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6790",
    "data-name": "Group 6790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6789",
    "data-name": "Group 6789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6788",
    "data-name": "Group 6788"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 61.938,
    height: 64.563,
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6810",
    "data-name": "Group 6810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6802",
    "data-name": "Group 6802",
    transform: "translate(0.022 0.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6801",
    "data-name": "Group 6801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6800",
    "data-name": "Group 6800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6799",
    "data-name": "Group 6799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6798",
    "data-name": "Group 6798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6797",
    "data-name": "Group 6797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6796",
    "data-name": "Group 6796"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 61.938,
    height: 64.563,
    fill: "#fafafa"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6809",
    "data-name": "Group 6809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6808",
    "data-name": "Group 6808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6807",
    "data-name": "Group 6807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6806",
    "data-name": "Group 6806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6805",
    "data-name": "Group 6805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6804",
    "data-name": "Group 6804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6803",
    "data-name": "Group 6803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11803",
    "data-name": "Path 11803",
    d: "M391.864,220.089H329.89v-64.6h61.974Zm-61.938-.037H391.82V155.527H329.927Z",
    transform: "translate(-329.89 -155.49)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6818",
    "data-name": "Group 6818",
    transform: "translate(8.343 8.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6817",
    "data-name": "Group 6817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6816",
    "data-name": "Group 6816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6815",
    "data-name": "Group 6815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6814",
    "data-name": "Group 6814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6813",
    "data-name": "Group 6813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6812",
    "data-name": "Group 6812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6811",
    "data-name": "Group 6811"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 45.282,
    height: 47.204,
    fill: "#fff"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6827",
    "data-name": "Group 6827",
    transform: "translate(0.071 56.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6826",
    "data-name": "Group 6826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6825",
    "data-name": "Group 6825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6824",
    "data-name": "Group 6824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6823",
    "data-name": "Group 6823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6822",
    "data-name": "Group 6822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6821",
    "data-name": "Group 6821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6820",
    "data-name": "Group 6820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6819",
    "data-name": "Group 6819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11804",
    "data-name": "Path 11804",
    d: "M338.259,232.379a7.445,7.445,0,0,1-1.119,1.3c-.724.76-1.74,1.8-2.881,2.917s-2.186,2.12-2.961,2.83a7.594,7.594,0,0,1-1.309,1.089,7.3,7.3,0,0,1,1.111-1.294c.724-.76,1.74-1.8,2.888-2.925s2.194-2.128,2.961-2.837A7.188,7.188,0,0,1,338.259,232.379Z",
    transform: "translate(-329.987 -232.376)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6836",
    "data-name": "Group 6836",
    transform: "translate(53.622 56.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6835",
    "data-name": "Group 6835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6834",
    "data-name": "Group 6834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6833",
    "data-name": "Group 6833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6832",
    "data-name": "Group 6832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6831",
    "data-name": "Group 6831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6830",
    "data-name": "Group 6830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6829",
    "data-name": "Group 6829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6828",
    "data-name": "Group 6828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11805",
    "data-name": "Path 11805",
    d: "M403.229,232.219a7.444,7.444,0,0,1,1.3,1.119c.76.724,1.8,1.74,2.917,2.881s2.12,2.186,2.83,2.961a7.582,7.582,0,0,1,1.089,1.309,7.3,7.3,0,0,1-1.294-1.111c-.76-.724-1.8-1.74-2.925-2.888s-2.128-2.193-2.837-2.961A8.079,8.079,0,0,1,403.229,232.219Z",
    transform: "translate(-403.227 -232.217)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6845",
    "data-name": "Group 6845",
    transform: "translate(53.505 0.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6844",
    "data-name": "Group 6844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6843",
    "data-name": "Group 6843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6842",
    "data-name": "Group 6842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6841",
    "data-name": "Group 6841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6840",
    "data-name": "Group 6840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6839",
    "data-name": "Group 6839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6838",
    "data-name": "Group 6838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6837",
    "data-name": "Group 6837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11806",
    "data-name": "Path 11806",
    d: "M403.069,164.567a7.443,7.443,0,0,1,1.119-1.3c.724-.76,1.74-1.8,2.881-2.917s2.186-2.12,2.961-2.83a7.59,7.59,0,0,1,1.309-1.089,7.3,7.3,0,0,1-1.111,1.294c-.724.76-1.74,1.8-2.888,2.925s-2.194,2.128-2.961,2.837A7.5,7.5,0,0,1,403.069,164.567Z",
    transform: "translate(-403.067 -156.427)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6854",
    "data-name": "Group 6854",
    transform: "translate(0.078 0.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6853",
    "data-name": "Group 6853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6852",
    "data-name": "Group 6852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6851",
    "data-name": "Group 6851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6850",
    "data-name": "Group 6850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6849",
    "data-name": "Group 6849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6848",
    "data-name": "Group 6848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6847",
    "data-name": "Group 6847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6846",
    "data-name": "Group 6846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11807",
    "data-name": "Path 11807",
    d: "M338.137,164.679a7.443,7.443,0,0,1-1.3-1.119c-.76-.724-1.8-1.74-2.917-2.881s-2.12-2.186-2.83-2.961A7.591,7.591,0,0,1,330,156.409a7.3,7.3,0,0,1,1.294,1.111c.76.724,1.8,1.74,2.925,2.888s2.128,2.194,2.837,2.961A6.908,6.908,0,0,1,338.137,164.679Z",
    transform: "translate(-329.997 -156.407)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6863",
    "data-name": "Group 6863",
    transform: "translate(8.145 8.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6862",
    "data-name": "Group 6862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6861",
    "data-name": "Group 6861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6860",
    "data-name": "Group 6860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6859",
    "data-name": "Group 6859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6858",
    "data-name": "Group 6858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6857",
    "data-name": "Group 6857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6856",
    "data-name": "Group 6856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6855",
    "data-name": "Group 6855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11808",
    "data-name": "Path 11808",
    d: "M386.392,214.519s-.007-.08-.007-.227-.007-.38-.007-.658c-.007-.592-.015-1.44-.022-2.552-.007-2.237-.029-5.491-.044-9.622-.022-8.27-.051-20.041-.088-34.146l.175.175c-13.183.007-28.662.015-45.157.029h-.007l.2-.2c-.007,17.329-.022,33.532-.029,47.2l-.176-.175,32.7.088c3.948.022,7.049.037,9.184.044,1.053.007,1.864.015,2.427.022.271.007.475.007.629.007a1.157,1.157,0,0,1,.227.007s-.066.007-.2.007-.351.007-.607.007c-.556.007-1.36.015-2.4.022-2.128.007-5.213.029-9.147.044l-32.808.088h-.175v-.175c-.007-13.673-.015-29.876-.029-47.2v-.2h.2c16.488.007,31.974.015,45.157.029h.175v.175c-.036,14.148-.066,25.964-.088,34.255-.022,4.117-.037,7.356-.044,9.578-.007,1.089-.015,1.93-.022,2.515-.007.271-.007.483-.007.643C386.392,214.446,386.392,214.519,386.392,214.519Z",
    transform: "translate(-341.03 -167.11)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6871",
    "data-name": "Group 6871",
    transform: "translate(23.434 24.743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6870",
    "data-name": "Group 6870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6869",
    "data-name": "Group 6869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6868",
    "data-name": "Group 6868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6867",
    "data-name": "Group 6867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6866",
    "data-name": "Group 6866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6865",
    "data-name": "Group 6865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6864",
    "data-name": "Group 6864"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 15.113,
    height: 15.113,
    fill: "#ebebeb"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(37.39 204.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7031",
    "data-name": "Group 7031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6877",
    "data-name": "Group 6877",
    transform: "translate(20.395 82.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6874",
    "data-name": "Group 6874",
    transform: "translate(0.073 0.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6873",
    "data-name": "Group 6873"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 44.331,
    height: 6.091,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6876",
    "data-name": "Group 6876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6875",
    "data-name": "Group 6875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11809",
    "data-name": "Path 11809",
    d: "M156.785,432.324H112.3V426.08h44.485Zm-44.331-.154h44.177v-5.937H112.454v5.937Z",
    transform: "translate(-112.3 -426.08)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6880",
    "data-name": "Group 6880",
    transform: "translate(24.577 87.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6879",
    "data-name": "Group 6879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6878",
    "data-name": "Group 6878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11810",
    "data-name": "Path 11810",
    d: "M118.02,431.74l6.383,31.484h23.61l6.171-29.452Z",
    transform: "translate(-118.02 -431.74)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6883",
    "data-name": "Group 6883",
    transform: "translate(24.577 115.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6882",
    "data-name": "Group 6882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6881",
    "data-name": "Group 6881"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11811",
    "data-name": "Path 11811",
    d: "M118.02,470.73l3.407,4.679h28.7l4.058-4.679Z",
    transform: "translate(-118.02 -470.73)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6887",
    "data-name": "Group 6887",
    transform: "translate(40.696 22.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6886",
    "data-name": "Group 6886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6885",
    "data-name": "Group 6885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6884",
    "data-name": "Group 6884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11812",
    "data-name": "Path 11812",
    d: "M140.339,409.047c-.088,0-.2-14.587-.249-32.574s-.022-32.574.066-32.574.2,14.58.249,32.574S140.427,409.047,140.339,409.047Z",
    transform: "translate(-140.066 -343.9)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6891",
    "data-name": "Group 6891",
    transform: "translate(46.764 51.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6890",
    "data-name": "Group 6890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6889",
    "data-name": "Group 6889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6888",
    "data-name": "Group 6888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11813",
    "data-name": "Path 11813",
    d: "M152.449,383.08a1.463,1.463,0,0,1-.117.336q-.154.373-.395.943c-.088.2-.183.431-.292.68s-.19.534-.292.826-.219.614-.344.951-.212.7-.329,1.082a44.85,44.85,0,0,0-1.243,5.425,67.053,67.053,0,0,0-.687,6.785,90.956,90.956,0,0,0,.351,12.4c.146,1.579.285,2.859.395,3.744.044.417.08.753.11,1.016a1.213,1.213,0,0,1,.015.358,1.974,1.974,0,0,1-.08-.351c-.044-.263-.1-.6-.168-1.009-.146-.877-.322-2.157-.49-3.736a82.046,82.046,0,0,1-.446-12.437,61.7,61.7,0,0,1,.717-6.822,40.369,40.369,0,0,1,1.316-5.447c.124-.38.227-.746.351-1.082s.249-.651.366-.951.219-.57.322-.819.219-.468.314-.673c.183-.373.336-.68.453-.921A1.32,1.32,0,0,1,152.449,383.08Z",
    transform: "translate(-148.365 -383.08)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6895",
    "data-name": "Group 6895",
    transform: "translate(43.953 39.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6894",
    "data-name": "Group 6894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6893",
    "data-name": "Group 6893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6892",
    "data-name": "Group 6892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11814",
    "data-name": "Path 11814",
    d: "M150.282,366.95a3.148,3.148,0,0,1-.139.483c-.117.336-.271.79-.461,1.353-.1.3-.219.622-.336.98s-.227.76-.358,1.177c-.256.841-.563,1.806-.826,2.881-.139.541-.292,1.1-.446,1.689q-.2.888-.417,1.843c-.307,1.272-.534,2.647-.819,4.087-.49,2.9-.921,6.1-1.214,9.476s-.4,6.61-.446,9.549c-.007,2.939.029,5.586.146,7.809.037,1.111.11,2.113.168,3s.11,1.638.161,2.259q.066.9.11,1.426a2.321,2.321,0,0,1,.015.5,3.9,3.9,0,0,1-.08-.5c-.044-.351-.1-.826-.168-1.426q-.11-.932-.219-2.259c-.073-.885-.161-1.886-.212-3-.146-2.223-.212-4.877-.219-7.824.029-2.947.139-6.186.424-9.571s.738-6.6,1.243-9.5c.292-1.44.526-2.822.848-4.095.154-.636.292-1.25.431-1.843.161-.585.314-1.148.468-1.689.278-1.075.6-2.033.877-2.874.139-.417.263-.812.38-1.17s.256-.673.366-.972c.219-.563.388-1,.519-1.338A2.717,2.717,0,0,1,150.282,366.95Z",
    transform: "translate(-144.52 -366.95)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6899",
    "data-name": "Group 6899",
    transform: "translate(29.715 24.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6898",
    "data-name": "Group 6898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6897",
    "data-name": "Group 6897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6896",
    "data-name": "Group 6896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11815",
    "data-name": "Path 11815",
    d: "M133.5,412.354a.525.525,0,0,1-.022-.168q-.011-.2-.044-.5-.044-.7-.132-1.93c-.11-1.7-.256-4.124-.446-7.107-.388-6-.943-14.28-1.952-23.4-.519-4.555-1.111-8.884-1.733-12.8-.329-1.96-.629-3.824-.972-5.557-.314-1.74-.651-3.349-.958-4.818s-.614-2.793-.877-3.956-.5-2.164-.717-2.976-.351-1.426-.461-1.879c-.044-.2-.08-.366-.11-.49a.731.731,0,0,1-.029-.168.743.743,0,0,1,.058.161c.037.124.08.285.139.483.124.446.3,1.075.519,1.864.227.812.49,1.806.768,2.969s.621,2.479.921,3.948c.322,1.47.673,3.078.994,4.818.351,1.733.658,3.6,1,5.557.636,3.926,1.243,8.255,1.762,12.817,1.009,9.118,1.528,17.417,1.857,23.419.161,3,.278,5.433.344,7.114.029.819.051,1.47.073,1.938.007.2.007.373.007.5A.671.671,0,0,1,133.5,412.354Z",
    transform: "translate(-125.047 -346.6)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6902",
    "data-name": "Group 6902",
    transform: "translate(26.66 26.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6901",
    "data-name": "Group 6901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6900",
    "data-name": "Group 6900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11816",
    "data-name": "Path 11816",
    d: "M134.82,352.148a4.393,4.393,0,0,0-4.358-3.649,6.852,6.852,0,0,0-5.279,2.866A16.609,16.609,0,0,0,122.639,357a38.3,38.3,0,0,0-1.565,15.011,22.749,22.749,0,0,0,6.244,13.534,2.566,2.566,0,0,0,2.15.987,2.6,2.6,0,0,0,1.133-.7,33.6,33.6,0,0,0,10.9-25.547,10.39,10.39,0,0,0-1.367-5.5c-1.06-1.594-3.517-3.276-5.316-2.64",
    transform: "translate(-120.869 -348.5)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6922",
    "data-name": "Group 6922",
    transform: "translate(13.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6905",
    "data-name": "Group 6905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6904",
    "data-name": "Group 6904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6903",
    "data-name": "Group 6903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11817",
    "data-name": "Path 11817",
    d: "M130.255,335.505q-13.183-7.776-26.359-15.552a1.217,1.217,0,0,1-.643-.651c-.1-.388.19-.768.468-1.053a18.182,18.182,0,0,1,14.082-5.535,16.1,16.1,0,0,1,12.737,7.919c2.552,4.548,2.632,10.558-.285,14.872",
    transform: "translate(-103.231 -312.673)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6909",
    "data-name": "Group 6909",
    transform: "translate(4.466 2.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6908",
    "data-name": "Group 6908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6907",
    "data-name": "Group 6907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6906",
    "data-name": "Group 6906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11818",
    "data-name": "Path 11818",
    d: "M109.34,315.8a2.144,2.144,0,0,1,.344-.044c.227-.015.563-.051.994-.051a19.67,19.67,0,0,1,3.656.292A21.111,21.111,0,0,1,129.3,326.413a21.246,21.246,0,0,1,2.091,5.023,19.57,19.57,0,0,1,.651,3.612,7.622,7.622,0,0,1,.044.768,1.236,1.236,0,0,1-.2.578,4.519,4.519,0,0,0,.044-1.331A21.632,21.632,0,0,0,114.3,316.228a22.54,22.54,0,0,0-3.619-.388C109.815,315.818,109.34,315.833,109.34,315.8Z",
    transform: "translate(-109.34 -315.704)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6913",
    "data-name": "Group 6913",
    transform: "translate(13.964 12.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6912",
    "data-name": "Group 6912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6911",
    "data-name": "Group 6911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6910",
    "data-name": "Group 6910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11819",
    "data-name": "Path 11819",
    d: "M131.821,329.217a6.34,6.34,0,0,1-1.331.607c-.841.329-2.011.753-3.327,1.17s-2.515.746-3.393.965a6.158,6.158,0,0,1-1.44.271,7.146,7.146,0,0,1,1.375-.49c.972-.307,2.106-.658,3.356-1.046s2.376-.768,3.349-1.082A6.948,6.948,0,0,1,131.821,329.217Z",
    transform: "translate(-122.33 -329.21)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6917",
    "data-name": "Group 6917",
    transform: "translate(19.251 0.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6916",
    "data-name": "Group 6916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6915",
    "data-name": "Group 6915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6914",
    "data-name": "Group 6914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11820",
    "data-name": "Path 11820",
    d: "M129.611,313.97a11.161,11.161,0,0,1,.314,2.939,11.409,11.409,0,0,1-.161,2.954,18.826,18.826,0,0,1-.154-2.947A18.3,18.3,0,0,1,129.611,313.97Z",
    transform: "translate(-129.561 -313.97)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6921",
    "data-name": "Group 6921",
    transform: "translate(0.437 3.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6920",
    "data-name": "Group 6920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6919",
    "data-name": "Group 6919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6918",
    "data-name": "Group 6918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11821",
    "data-name": "Path 11821",
    d: "M103.83,321.035a10.99,10.99,0,0,1,1.916-.673c1.2-.366,2.866-.834,4.723-1.287s3.561-.79,4.789-1.009a11.133,11.133,0,0,1,2.011-.271,14.042,14.042,0,0,1-1.967.49c-1.221.271-2.91.651-4.76,1.1s-3.524.877-4.738,1.192A14.128,14.128,0,0,1,103.83,321.035Z",
    transform: "translate(-103.83 -317.786)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6946",
    "data-name": "Group 6946",
    transform: "translate(0 23.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6925",
    "data-name": "Group 6925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6924",
    "data-name": "Group 6924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6923",
    "data-name": "Group 6923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11822",
    "data-name": "Path 11822",
    d: "M114.073,346.638c-2.267-1.718-4.665-2.055-7.509-1.945a22.923,22.923,0,0,0-8.218,2.12c-4.446,1.945-8.621,4.818-11.275,8.876s-3.583,9.439-1.594,13.863a1.966,1.966,0,0,0,.9,1.089,2.141,2.141,0,0,0,1.484-.117c5.052-1.652,10.149-3.312,14.792-5.893s8.876-6.171,11.37-10.865a9.385,9.385,0,0,0,1.2-3.6,4.436,4.436,0,0,0-1.148-3.524",
    transform: "translate(-84.407 -344.674)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6929",
    "data-name": "Group 6929",
    transform: "translate(1.749 1.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6928",
    "data-name": "Group 6928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6927",
    "data-name": "Group 6927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6926",
    "data-name": "Group 6926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11823",
    "data-name": "Path 11823",
    d: "M114.767,346.63a2.649,2.649,0,0,1-.366.146c-.271.1-.621.212-1.06.366-.234.08-.49.161-.768.256s-.578.227-.9.351c-.636.256-1.382.519-2.164.9-.395.183-.812.366-1.243.563s-.855.446-1.316.673c-.914.453-1.843,1.024-2.83,1.609A44.7,44.7,0,0,0,92.963,361.3c-.7.907-1.389,1.755-1.952,2.6-.285.424-.585.819-.834,1.214s-.49.79-.717,1.155c-.475.724-.826,1.433-1.163,2.033-.161.3-.329.578-.461.841s-.241.5-.351.731c-.2.409-.366.746-.5,1a2.876,2.876,0,0,1-.19.344,1.993,1.993,0,0,1,.132-.366c.117-.263.263-.607.446-1.031q.154-.34.329-.746c.124-.271.278-.548.439-.863.322-.614.665-1.323,1.126-2.062.227-.373.461-.768.7-1.177s.541-.8.826-1.236c.556-.863,1.243-1.718,1.945-2.64a46.819,46.819,0,0,1,5.184-5.425,46.255,46.255,0,0,1,6.04-4.445c1-.578,1.938-1.148,2.866-1.594.461-.227.892-.468,1.331-.658s.855-.373,1.258-.548c.79-.366,1.543-.614,2.194-.855.329-.117.629-.234.907-.329s.541-.161.775-.234c.446-.124.8-.227,1.082-.307A2.647,2.647,0,0,1,114.767,346.63Z",
    transform: "translate(-86.799 -346.628)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6933",
    "data-name": "Group 6933",
    transform: "translate(0.887 11.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6932",
    "data-name": "Group 6932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6931",
    "data-name": "Group 6931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6930",
    "data-name": "Group 6930"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11824",
    "data-name": "Path 11824",
    d: "M96.734,359.747a54.807,54.807,0,0,1-5.513,1.777A54.555,54.555,0,0,1,85.62,363a54.814,54.814,0,0,1,5.513-1.777A50.355,50.355,0,0,1,96.734,359.747Z",
    transform: "translate(-85.62 -359.739)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6937",
    "data-name": "Group 6937",
    transform: "translate(11.627 11.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6936",
    "data-name": "Group 6936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6935",
    "data-name": "Group 6935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6934",
    "data-name": "Group 6934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11825",
    "data-name": "Path 11825",
    d: "M100.456,372.078a8.592,8.592,0,0,1-.124-1.718c-.029-1.06-.037-2.53.015-4.153s.132-3.086.219-4.146a8.593,8.593,0,0,1,.219-1.711,9.989,9.989,0,0,1,.007,1.718c-.037,1.163-.08,2.581-.124,4.146s-.073,2.976-.1,4.146A8.735,8.735,0,0,1,100.456,372.078Z",
    transform: "translate(-100.309 -360.35)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6941",
    "data-name": "Group 6941",
    transform: "translate(21.249 4.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6940",
    "data-name": "Group 6940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6939",
    "data-name": "Group 6939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6938",
    "data-name": "Group 6938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11826",
    "data-name": "Path 11826",
    d: "M114.42,364.214c-.088.007-.366-2.976-.622-6.661s-.388-6.683-.307-6.683.366,2.976.621,6.661S114.508,364.214,114.42,364.214Z",
    transform: "translate(-113.468 -350.87)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6945",
    "data-name": "Group 6945",
    transform: "translate(9.222 4.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6944",
    "data-name": "Group 6944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6943",
    "data-name": "Group 6943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6942",
    "data-name": "Group 6942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11827",
    "data-name": "Path 11827",
    d: "M97.02,350.451a9.982,9.982,0,0,1,1.769-.051c1.089.007,2.6.037,4.255.1s3.166.124,4.255.19a10.1,10.1,0,0,1,1.762.168,9.861,9.861,0,0,1-1.762.051c-1.089-.007-2.6-.037-4.255-.1s-3.166-.124-4.255-.19A9.315,9.315,0,0,1,97.02,350.451Z",
    transform: "translate(-97.02 -350.398)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6950",
    "data-name": "Group 6950",
    transform: "translate(34.134 29.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6949",
    "data-name": "Group 6949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6948",
    "data-name": "Group 6948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6947",
    "data-name": "Group 6947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11828",
    "data-name": "Path 11828",
    d: "M131.207,387.619a1.973,1.973,0,0,1-.037-.351c-.015-.263-.029-.6-.044-1.016-.037-.877-.051-2.157-.015-3.736s.139-3.451.322-5.528c.2-2.077.5-4.35.929-6.719s.958-4.606,1.5-6.624,1.119-3.809,1.645-5.3.98-2.683,1.331-3.495c.161-.38.292-.687.4-.936a1.472,1.472,0,0,1,.161-.322,1.411,1.411,0,0,1-.1.344c-.088.249-.2.563-.344.958-.314.826-.738,2.025-1.236,3.524s-1.038,3.29-1.572,5.3-1.038,4.248-1.47,6.6-.731,4.628-.951,6.7-.336,3.934-.395,5.506-.088,2.844-.088,3.722c-.007.409-.007.746-.015,1.016A2.413,2.413,0,0,1,131.207,387.619Z",
    transform: "translate(-131.091 -353.59)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6954",
    "data-name": "Group 6954",
    transform: "translate(27.647 46.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6953",
    "data-name": "Group 6953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6952",
    "data-name": "Group 6952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6951",
    "data-name": "Group 6951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11829",
    "data-name": "Path 11829",
    d: "M130.211,376.519a7.5,7.5,0,0,1-1.053,1.155c-.68.68-1.652,1.594-2.757,2.559s-2.135,1.806-2.9,2.4a7.866,7.866,0,0,1-1.28.892,8.361,8.361,0,0,1,1.141-1.068c.812-.7,1.769-1.535,2.837-2.464s2-1.777,2.808-2.486A8.2,8.2,0,0,1,130.211,376.519Z",
    transform: "translate(-122.218 -376.518)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6958",
    "data-name": "Group 6958",
    transform: "translate(36.529 42.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6957",
    "data-name": "Group 6957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6956",
    "data-name": "Group 6956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6955",
    "data-name": "Group 6955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11830",
    "data-name": "Path 11830",
    d: "M141.82,381.774a13.344,13.344,0,0,1-1.119-1.55c-.724-1.053-1.616-2.354-2.6-3.8-1.009-1.433-1.923-2.72-2.661-3.766a12.275,12.275,0,0,1-1.068-1.587,10.238,10.238,0,0,1,1.243,1.455c.731.929,1.711,2.237,2.742,3.714s1.916,2.852,2.53,3.861A10.8,10.8,0,0,1,141.82,381.774Z",
    transform: "translate(-134.367 -371.068)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6962",
    "data-name": "Group 6962",
    transform: "translate(27.062 32.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6961",
    "data-name": "Group 6961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6960",
    "data-name": "Group 6960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6959",
    "data-name": "Group 6959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11831",
    "data-name": "Path 11831",
    d: "M133.967,356.809c.044.073-2.727,1.938-6.186,4.168s-6.31,3.978-6.361,3.9,2.72-1.938,6.193-4.168S133.916,356.736,133.967,356.809Z",
    transform: "translate(-121.419 -356.807)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6966",
    "data-name": "Group 6966",
    transform: "translate(39.265 32.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6965",
    "data-name": "Group 6965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6964",
    "data-name": "Group 6964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6963",
    "data-name": "Group 6963"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11832",
    "data-name": "Path 11832",
    d: "M146.269,365.406a51.592,51.592,0,0,1-4.19-3.875,51.452,51.452,0,0,1-3.97-4.1,51.6,51.6,0,0,1,4.19,3.875A54.552,54.552,0,0,1,146.269,365.406Z",
    transform: "translate(-138.108 -357.428)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6990",
    "data-name": "Group 6990",
    transform: "translate(49.386 23.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6969",
    "data-name": "Group 6969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6968",
    "data-name": "Group 6968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6967",
    "data-name": "Group 6967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11833",
    "data-name": "Path 11833",
    d: "M151.95,361.708l2.376-.2a11.72,11.72,0,0,0,4.8-1.47,20,20,0,0,1,2.237-1.126c2.939-1.177,6.222-.972,9.388-1.126a38.838,38.838,0,0,0,14.938-3.817,1.46,1.46,0,0,0,.651-.592c.49-.892-.417-1.682-1.2-2.164-4.007-2.471-8.087-4.972-12.635-6.2s-9.7-1.016-13.585,1.652c-4.541,3.137-6.2,9.571-6.975,15.04",
    transform: "translate(-151.95 -344.294)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6973",
    "data-name": "Group 6973",
    transform: "translate(0.05 2.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6972",
    "data-name": "Group 6972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6971",
    "data-name": "Group 6971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6970",
    "data-name": "Group 6970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11834",
    "data-name": "Path 11834",
    d: "M186.421,353.911a2.625,2.625,0,0,1-.4-.19c-.285-.146-.658-.344-1.126-.592-.98-.512-2.384-1.272-4.168-2.128a38.832,38.832,0,0,0-6.449-2.486,21.3,21.3,0,0,0-8.357-.68A14.29,14.29,0,0,0,158.3,351.1a16.838,16.838,0,0,0-3.963,5.572c-.834,1.784-1.353,3.3-1.726,4.336-.176.5-.314.9-.424,1.2a2.04,2.04,0,0,1-.168.409,3.536,3.536,0,0,1,.1-.431c.1-.307.212-.717.366-1.221a40.012,40.012,0,0,1,1.638-4.394,16.83,16.83,0,0,1,3.978-5.7,14.42,14.42,0,0,1,7.772-3.363,21.29,21.29,0,0,1,8.474.709,36.805,36.805,0,0,1,6.464,2.566c1.769.885,3.166,1.674,4.124,2.223.453.263.819.483,1.1.643A2.577,2.577,0,0,1,186.421,353.911Z",
    transform: "translate(-152.019 -347.359)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6977",
    "data-name": "Group 6977",
    transform: "translate(15.025 2.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6976",
    "data-name": "Group 6976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6975",
    "data-name": "Group 6975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6974",
    "data-name": "Group 6974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11835",
    "data-name": "Path 11835",
    d: "M186.217,357.116c-.051.073-3.159-1.938-6.946-4.5s-6.822-4.687-6.771-4.76,3.159,1.938,6.946,4.5S186.26,357.043,186.217,357.116Z",
    transform: "translate(-172.499 -347.857)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6981",
    "data-name": "Group 6981",
    transform: "translate(20.846 2.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6980",
    "data-name": "Group 6980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6979",
    "data-name": "Group 6979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6978",
    "data-name": "Group 6978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11836",
    "data-name": "Path 11836",
    d: "M185.037,347.632a7.642,7.642,0,0,1-2.267.409,7.484,7.484,0,0,1-2.311-.029,15.884,15.884,0,0,1,2.281-.234A15.343,15.343,0,0,1,185.037,347.632Z",
    transform: "translate(-180.46 -347.609)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6985",
    "data-name": "Group 6985",
    transform: "translate(9.476 0.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6984",
    "data-name": "Group 6984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6983",
    "data-name": "Group 6983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6982",
    "data-name": "Group 6982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11837",
    "data-name": "Path 11837",
    d: "M167.235,345.209a6.016,6.016,0,0,1-1.024,1.594,6.685,6.685,0,0,1-1.294,1.47,6.016,6.016,0,0,1,1.024-1.594A6.9,6.9,0,0,1,167.235,345.209Z",
    transform: "translate(-164.909 -345.208)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6989",
    "data-name": "Group 6989",
    transform: "translate(5.11 6.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6988",
    "data-name": "Group 6988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6987",
    "data-name": "Group 6987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6986",
    "data-name": "Group 6986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11838",
    "data-name": "Path 11838",
    d: "M168.416,360.557a7.912,7.912,0,0,1-1.5-.812c-.9-.548-2.113-1.345-3.415-2.289s-2.442-1.835-3.268-2.486a9.406,9.406,0,0,1-1.294-1.111,8.653,8.653,0,0,1,1.426.929c.936.68,2.062,1.5,3.312,2.406,1.294.936,2.479,1.762,3.349,2.354A10.79,10.79,0,0,1,168.416,360.557Z",
    transform: "translate(-158.939 -353.857)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7014",
    "data-name": "Group 7014",
    transform: "translate(47.325 49.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6993",
    "data-name": "Group 6993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6992",
    "data-name": "Group 6992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6991",
    "data-name": "Group 6991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11839",
    "data-name": "Path 11839",
    d: "M154.7,381.544c-2.267-.6-4.972,1.609-5.44,3.9s.395,4.65,1.4,6.771a34.651,34.651,0,0,0,9.381,12.276,23.184,23.184,0,0,0,14.346,5.279c-.958-4.453.256-9.11-.278-13.636a17.733,17.733,0,0,0-15.706-15.552c-1.455-.154-3.129-.38-3.707.958",
    transform: "translate(-149.131 -380.469)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6997",
    "data-name": "Group 6997",
    transform: "translate(5.569 1.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6996",
    "data-name": "Group 6996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6995",
    "data-name": "Group 6995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6994",
    "data-name": "Group 6994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11840",
    "data-name": "Path 11840",
    d: "M176.44,410.175a1.594,1.594,0,0,1-.322-.154,5.876,5.876,0,0,1-.848-.57,8.888,8.888,0,0,1-2.237-3c-.358-.7-.768-1.462-1.163-2.31s-.79-1.747-1.221-2.7a25.262,25.262,0,0,0-1.5-2.881,22.6,22.6,0,0,0-2.062-2.808c-1.55-1.828-3.217-3.4-4.665-4.913a31.565,31.565,0,0,1-3.561-4.27,15.849,15.849,0,0,1-1.74-3.32,9.682,9.682,0,0,1-.3-.972,1.682,1.682,0,0,1-.073-.351c.029-.007.161.461.49,1.28a16.908,16.908,0,0,0,1.806,3.239,33.7,33.7,0,0,0,3.583,4.19c1.448,1.492,3.129,3.064,4.694,4.914a22.941,22.941,0,0,1,2.091,2.852,25.211,25.211,0,0,1,1.5,2.925c.417.951.819,1.857,1.192,2.705s.775,1.609,1.119,2.318a9.158,9.158,0,0,0,2.12,3.005C176.009,409.927,176.462,410.139,176.44,410.175Z",
    transform: "translate(-156.748 -381.93)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7001",
    "data-name": "Group 7001",
    transform: "translate(13.513 15.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7000",
    "data-name": "Group 7000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6999",
    "data-name": "Group 6999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6998",
    "data-name": "Group 6998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11841",
    "data-name": "Path 11841",
    d: "M167.625,411.783a6.651,6.651,0,0,1,.2-1.528c.176-.936.468-2.215.863-3.612s.819-2.647,1.148-3.532a6.409,6.409,0,0,1,.622-1.411,7.8,7.8,0,0,1-.409,1.484c-.278.907-.665,2.157-1.06,3.546s-.717,2.661-.951,3.576A7.456,7.456,0,0,1,167.625,411.783Z",
    transform: "translate(-167.613 -401.7)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7005",
    "data-name": "Group 7005",
    transform: "translate(13.928 12.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7004",
    "data-name": "Group 7004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7003",
    "data-name": "Group 7003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7002",
    "data-name": "Group 7002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11842",
    "data-name": "Path 11842",
    d: "M179.082,399.623a9.172,9.172,0,0,1-1.6-.366c-.98-.256-2.325-.607-3.831-.943s-2.874-.6-3.868-.79a9.857,9.857,0,0,1-1.6-.351,7.5,7.5,0,0,1,1.638.132c1,.132,2.391.366,3.9.7s2.859.724,3.824,1.038A7.677,7.677,0,0,1,179.082,399.623Z",
    transform: "translate(-168.18 -397.158)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7009",
    "data-name": "Group 7009",
    transform: "translate(5.099 6.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7008",
    "data-name": "Group 7008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7007",
    "data-name": "Group 7007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7006",
    "data-name": "Group 7006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11843",
    "data-name": "Path 11843",
    d: "M156.116,400.56a8.694,8.694,0,0,1,.249-1.769c.2-1.082.519-2.574.943-4.2s.877-3.086,1.228-4.124a8.849,8.849,0,0,1,.651-1.66,10.815,10.815,0,0,1-.439,1.726c-.3,1.06-.717,2.515-1.141,4.138s-.775,3.1-1.031,4.168A11.333,11.333,0,0,1,156.116,400.56Z",
    transform: "translate(-156.105 -388.81)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7013",
    "data-name": "Group 7013",
    transform: "translate(7.004 3.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7012",
    "data-name": "Group 7012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7011",
    "data-name": "Group 7011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7010",
    "data-name": "Group 7010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11844",
    "data-name": "Path 11844",
    d: "M171.33,387c-.007.088-2.844-.146-6.325-.512s-6.3-.738-6.3-.826a62.2,62.2,0,0,1,6.325.512A61.815,61.815,0,0,1,171.33,387Z",
    transform: "translate(-158.71 -385.644)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7018",
    "data-name": "Group 7018",
    transform: "translate(20.387 88.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7017",
    "data-name": "Group 7017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7016",
    "data-name": "Group 7016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7015",
    "data-name": "Group 7015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11845",
    "data-name": "Path 11845",
    d: "M156.775,434.421c0,.088-9.959.161-22.242.161s-22.242-.073-22.242-.161,9.959-.161,22.242-.161S156.775,434.333,156.775,434.421Z",
    transform: "translate(-112.29 -434.26)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7022",
    "data-name": "Group 7022",
    transform: "translate(27.984 101.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7021",
    "data-name": "Group 7021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7020",
    "data-name": "Group 7020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7019",
    "data-name": "Group 7019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11846",
    "data-name": "Path 11846",
    d: "M152.643,451.951c0,.088-6.712.161-14.982.161s-14.982-.073-14.982-.161,6.7-.161,14.982-.161S152.643,451.863,152.643,451.951Z",
    transform: "translate(-122.68 -451.79)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7026",
    "data-name": "Group 7026",
    transform: "translate(28.233 103.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7025",
    "data-name": "Group 7025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7024",
    "data-name": "Group 7024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7023",
    "data-name": "Group 7023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11847",
    "data-name": "Path 11847",
    d: "M152.472,454.451c0,.088-6.6.161-14.726.161s-14.726-.073-14.726-.161,6.588-.161,14.726-.161S152.472,454.363,152.472,454.451Z",
    transform: "translate(-123.02 -454.29)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7030",
    "data-name": "Group 7030",
    transform: "translate(27.209 100.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7029",
    "data-name": "Group 7029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7028",
    "data-name": "Group 7028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7027",
    "data-name": "Group 7027"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11848",
    "data-name": "Path 11848",
    d: "M152.622,449.881c0,.088-6.939.161-15.5.161s-15.5-.073-15.5-.161,6.939-.161,15.5-.161S152.622,449.793,152.622,449.881Z",
    transform: "translate(-121.62 -449.72)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    transform: "translate(206.966 4.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7051",
    "data-name": "Group 7051",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7041",
    "data-name": "Group 7041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7040",
    "data-name": "Group 7040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7039",
    "data-name": "Group 7039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7038",
    "data-name": "Group 7038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7037",
    "data-name": "Group 7037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7033",
    "data-name": "Group 7033",
    transform: "translate(0 0.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7032",
    "data-name": "Group 7032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11849",
    "data-name": "Path 11849",
    d: "M316.33,88.729,321.85,79a26.048,26.048,0,1,1,6.237,6.939l.007.015Z",
    transform: "translate(-316.33 -39.36)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7036",
    "data-name": "Group 7036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7035",
    "data-name": "Group 7035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7034",
    "data-name": "Group 7034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11850",
    "data-name": "Path 11850",
    d: "M316.33,88.677c.592-.146,4.285-1.038,11.75-2.852l-.051.139-.007-.015a.082.082,0,0,1,.015-.117.088.088,0,0,1,.1,0,26.812,26.812,0,0,0,5.33,3.173,26.056,26.056,0,0,0,7.085,1.989,23.439,23.439,0,0,0,4.087.19c.7-.044,1.419-.059,2.135-.124.717-.11,1.44-.219,2.179-.336a26.025,26.025,0,0,0,16.071-10.361,25.765,25.765,0,0,0,4.336-9.937,26.208,26.208,0,0,0-.314-11.436,25.344,25.344,0,0,0-5.513-10.565l-1.053-1.155c-.344-.388-.753-.709-1.133-1.068-.395-.336-.746-.717-1.163-1.016l-1.236-.921a11.4,11.4,0,0,0-1.28-.848l-1.3-.79c-.453-.219-.914-.446-1.367-.665a12.74,12.74,0,0,0-1.375-.614A26.163,26.163,0,0,0,342.1,39.571a25.454,25.454,0,0,0-10.587,3.115A26.135,26.135,0,0,0,319.269,57.7a27.881,27.881,0,0,0-1.148,8.379,25.954,25.954,0,0,0,3.787,12.832.079.079,0,0,1,0,.08c-3.546,6.178-5.286,9.184-5.579,9.688.285-.512,1.974-3.539,5.447-9.768v.08a25.972,25.972,0,0,1-3.89-12.913,28.2,28.2,0,0,1,1.133-8.467A26.411,26.411,0,0,1,331.378,42.4a25.671,25.671,0,0,1,10.712-3.166,26.618,26.618,0,0,1,11.67,1.791,11.933,11.933,0,0,1,1.4.621c.461.227.921.446,1.382.673.439.263.877.534,1.323.8a10.155,10.155,0,0,1,1.294.855l1.25.936a15.616,15.616,0,0,1,1.177,1.031c.38.358.8.687,1.148,1.082l1.06,1.17a25.59,25.59,0,0,1,5.579,10.712,26.537,26.537,0,0,1,.307,11.582,25.947,25.947,0,0,1-4.4,10.061,26.25,26.25,0,0,1-16.269,10.441c-.746.11-1.477.219-2.2.329-.731.058-1.448.08-2.157.117a23.161,23.161,0,0,1-4.124-.212,26.028,26.028,0,0,1-7.136-2.04,26.342,26.342,0,0,1-5.352-3.232l.124-.117.007.015a.082.082,0,0,1-.015.117.056.056,0,0,1-.036.015C320.629,87.7,316.93,88.545,316.33,88.677Z",
    transform: "translate(-316.33 -39.167)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7050",
    "data-name": "Group 7050",
    transform: "translate(18.382 14.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7049",
    "data-name": "Group 7049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7048",
    "data-name": "Group 7048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7044",
    "data-name": "Group 7044",
    transform: "translate(4.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7043",
    "data-name": "Group 7043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7042",
    "data-name": "Group 7042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11851",
    "data-name": "Path 11851",
    d: "M348.1,67.473h1.7l3.7-5.155V58.94s2.618-.161,2.31,4.263.022,3.3.022,3.3,5.557.022,6.025.5c.336.351.49,5.871.548,8.869a3.244,3.244,0,0,1-2.3,3.268,2.414,2.414,0,0,1-.6.08c-1.389,0-8.474-1.126-8.474-1.126h-2.925V67.473Z",
    transform: "translate(-348.1 -58.939)",
    fill: "#008e76"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7047",
    "data-name": "Group 7047",
    transform: "translate(0 7.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7046",
    "data-name": "Group 7046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7045",
    "data-name": "Group 7045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11852",
    "data-name": "Path 11852",
    d: "M341.47,69.34l1.046,11.582h2.9V69.567Z",
    transform: "translate(-341.47 -69.34)",
    fill: "#008e76"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(103.065 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7279",
    "data-name": "Group 7279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11853",
    "data-name": "Path 11853",
    d: "M221.011,103.36a24.928,24.928,0,0,1-13.651,3.9,45.811,45.811,0,0,0-4.592-.051,6.964,6.964,0,0,0-4.2,1.631A3.828,3.828,0,0,0,197.489,113c.863,1.974,3.656,2.764,4.08,4.877.307,1.521-.826,2.969-2.106,3.853s-2.771,1.47-3.853,2.588a5.293,5.293,0,0,0,2.625,8.825c1.089.249,2.435.256,3.02,1.206a3.481,3.481,0,0,1,.161,2.289,8.222,8.222,0,0,0,.622,4.818A4.465,4.465,0,0,0,205.964,144c.643-.022,1.272-.219,1.916-.2a1.585,1.585,0,0,1,1.543.929,3.344,3.344,0,0,1-.059,1.316c-.234,2.157,1.916,3.839,4,4.46a14.377,14.377,0,0,0,12.313-2.515,23.712,23.712,0,0,0,7.6-10.368,70.554,70.554,0,0,0,3.407-12.547",
    transform: "translate(-179.582 -51.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7161",
    "data-name": "Group 7161",
    transform: "translate(7.185 147.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11854",
    "data-name": "Path 11854",
    d: "M274.28,246.29a9.078,9.078,0,0,0-2.055-3.064c-5.506-5.857-13.841-8.657-21.869-8.2s-15.7,3.948-21.95,9.008c-3.327,2.691-7.816,7.9-8.986,12.013,4.884,1.177,12.181-.461,16.788-2.471s9.162-4.438,14.163-4.95c5.791-.592,11.479,1.47,17.183,2.625a10.576,10.576,0,0,0,3.48.278A4.136,4.136,0,0,0,274,249.858,4.075,4.075,0,0,0,274.28,246.29Z",
    transform: "translate(-193.563 -234.975)",
    fill: "#008e76"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7052",
    "data-name": "Group 7052",
    transform: "translate(25.857)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11855",
    "data-name": "Path 11855",
    d: "M274.28,246.29a9.078,9.078,0,0,0-2.055-3.064c-5.506-5.857-13.841-8.657-21.869-8.2s-15.7,3.948-21.95,9.008c-3.327,2.691-7.816,7.9-8.986,12.013,4.884,1.177,12.181-.461,16.788-2.471s9.162-4.438,14.163-4.95c5.791-.592,11.479,1.47,17.183,2.625a10.576,10.576,0,0,0,3.48.278A4.136,4.136,0,0,0,274,249.858,4.075,4.075,0,0,0,274.28,246.29Z",
    transform: "translate(-219.42 -234.975)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7136",
    "data-name": "Group 7136",
    transform: "translate(68.426 54.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7135",
    "data-name": "Group 7135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7063",
    "data-name": "Group 7063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7062",
    "data-name": "Group 7062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7061",
    "data-name": "Group 7061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7060",
    "data-name": "Group 7060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7059",
    "data-name": "Group 7059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7058",
    "data-name": "Group 7058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7057",
    "data-name": "Group 7057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7056",
    "data-name": "Group 7056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7055",
    "data-name": "Group 7055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7054",
    "data-name": "Group 7054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7053",
    "data-name": "Group 7053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11856",
    "data-name": "Path 11856",
    d: "M285.939,335.928l13.943-9.037s13.863,11.136,16.6,9.717L299.941,308.94l-22.3,13.183Z",
    transform: "translate(-277.64 -308.94)",
    fill: "#008e76"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7075",
    "data-name": "Group 7075",
    transform: "translate(15.882 8.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7074",
    "data-name": "Group 7074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7073",
    "data-name": "Group 7073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7072",
    "data-name": "Group 7072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7071",
    "data-name": "Group 7071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7070",
    "data-name": "Group 7070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7069",
    "data-name": "Group 7069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7068",
    "data-name": "Group 7068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7067",
    "data-name": "Group 7067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7066",
    "data-name": "Group 7066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7065",
    "data-name": "Group 7065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7064",
    "data-name": "Group 7064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11857",
    "data-name": "Path 11857",
    d: "M299.4,322.191a1.311,1.311,0,0,1,.819-1.55,1.264,1.264,0,0,1,1.543.8,1.389,1.389,0,0,1-.877,1.638,1.307,1.307,0,0,1-1.514-1.009",
    transform: "translate(-299.361 -320.588)",
    fill: "#e0e0e0"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7086",
    "data-name": "Group 7086",
    transform: "translate(20.107 0.007)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7085",
    "data-name": "Group 7085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7084",
    "data-name": "Group 7084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7083",
    "data-name": "Group 7083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7082",
    "data-name": "Group 7082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7081",
    "data-name": "Group 7081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7080",
    "data-name": "Group 7080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7079",
    "data-name": "Group 7079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7078",
    "data-name": "Group 7078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7077",
    "data-name": "Group 7077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7076",
    "data-name": "Group 7076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11858",
    "data-name": "Path 11858",
    d: "M307.334,308.95l-2.194,1.418,16.685,25.993s1.272.914,2.055.256Z",
    transform: "translate(-305.14 -308.95)",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7098",
    "data-name": "Group 7098",
    transform: "translate(21.642 15.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7097",
    "data-name": "Group 7097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7096",
    "data-name": "Group 7096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7095",
    "data-name": "Group 7095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7094",
    "data-name": "Group 7094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7093",
    "data-name": "Group 7093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7092",
    "data-name": "Group 7092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7091",
    "data-name": "Group 7091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7090",
    "data-name": "Group 7090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7089",
    "data-name": "Group 7089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7088",
    "data-name": "Group 7088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7087",
    "data-name": "Group 7087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11859",
    "data-name": "Path 11859",
    d: "M307.964,332.955c.132-.088-.212-.8-.175-1.718.015-.929.395-1.616.263-1.711-.1-.11-.79.578-.812,1.7S307.861,333.065,307.964,332.955Z",
    transform: "translate(-307.239 -329.514)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7110",
    "data-name": "Group 7110",
    transform: "translate(24.976 17.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7109",
    "data-name": "Group 7109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7108",
    "data-name": "Group 7108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7107",
    "data-name": "Group 7107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7106",
    "data-name": "Group 7106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7105",
    "data-name": "Group 7105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7104",
    "data-name": "Group 7104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7103",
    "data-name": "Group 7103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7102",
    "data-name": "Group 7102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7101",
    "data-name": "Group 7101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7100",
    "data-name": "Group 7100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7099",
    "data-name": "Group 7099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11860",
    "data-name": "Path 11860",
    d: "M312.129,336.1c.146-.044.029-.768.329-1.572.271-.812.819-1.294.738-1.426-.051-.139-.9.241-1.25,1.243S312,336.171,312.129,336.1Z",
    transform: "translate(-311.799 -333.072)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7122",
    "data-name": "Group 7122",
    transform: "translate(27.985 20.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7121",
    "data-name": "Group 7121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7120",
    "data-name": "Group 7120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7119",
    "data-name": "Group 7119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7118",
    "data-name": "Group 7118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7117",
    "data-name": "Group 7117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7116",
    "data-name": "Group 7116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7115",
    "data-name": "Group 7115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7114",
    "data-name": "Group 7114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7113",
    "data-name": "Group 7113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7112",
    "data-name": "Group 7112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7111",
    "data-name": "Group 7111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11861",
    "data-name": "Path 11861",
    d: "M317.7,336.605c-.044-.139-.834.073-1.367.863s-.446,1.594-.3,1.587.307-.636.753-1.28S317.761,336.752,317.7,336.605Z",
    transform: "translate(-315.914 -336.566)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7134",
    "data-name": "Group 7134",
    transform: "translate(17.266 17.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7133",
    "data-name": "Group 7133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7132",
    "data-name": "Group 7132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7131",
    "data-name": "Group 7131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7130",
    "data-name": "Group 7130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7129",
    "data-name": "Group 7129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7128",
    "data-name": "Group 7128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7127",
    "data-name": "Group 7127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7126",
    "data-name": "Group 7126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7125",
    "data-name": "Group 7125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7124",
    "data-name": "Group 7124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7123",
    "data-name": "Group 7123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11862",
    "data-name": "Path 11862",
    d: "M302.947,335.468c.088-.132-.468-.636-.87-1.433-.424-.79-.519-1.535-.68-1.535-.146-.022-.3.863.19,1.791S302.881,335.6,302.947,335.468Z",
    transform: "translate(-301.254 -332.499)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11863",
    "data-name": "Path 11863",
    d: "M290.87,318.49l6.339,14.463-2.128,1.506-7.312-14.1Z",
    transform: "translate(-280.363 -311.507)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7160",
    "data-name": "Group 7160",
    transform: "translate(0 4.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11864",
    "data-name": "Path 11864",
    d: "M254.683,240.878c-.57,0-19.325-.409-29.452,6.273l-8.014,4.519.219,8.116s-1.718,2.866-1.338,4.584-.059,8.979-.059,8.979-3,.19-3.385,5.352c0,0-4.168,1.718-6,4.775s-20.553,37.443-21.7,42.986-1.908,15.281,2.3,18.528,13.563,2.1,13.563,2.1,1.338,4.014,9.549,4.2,20.824-9.359,20.824-9.359l37.824-25.788-8.95-19.164-13.212,8.087,14.134-16.429s6.493-11.077,4.584-22.732C264.152,257.249,254.683,240.878,254.683,240.878Z",
    transform: "translate(-184.056 -240.873)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7137",
    "data-name": "Group 7137",
    transform: "translate(33.447 5.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11865",
    "data-name": "Path 11865",
    d: "M270.219,248.92a1.756,1.756,0,0,1-.446.022c-.329,0-.753,0-1.272-.007-1.1-.007-2.705-.037-4.679-.015s-4.321.1-6.917.373a38.254,38.254,0,0,0-8.262,1.726,57.005,57.005,0,0,0-13.571,7.173c-1.594,1.1-2.9,2.011-3.846,2.662-.431.292-.775.534-1.046.724a2.479,2.479,0,0,1-.38.234,2.391,2.391,0,0,1,.336-.292c.263-.2.6-.461,1.009-.782.885-.665,2.164-1.623,3.78-2.764a53.95,53.95,0,0,1,13.6-7.312,37.5,37.5,0,0,1,8.35-1.718,67.968,67.968,0,0,1,6.953-.292c1.981.007,3.575.08,4.687.132.519.029.943.059,1.272.073A1.794,1.794,0,0,1,270.219,248.92Z",
    transform: "translate(-229.8 -248.649)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7138",
    "data-name": "Group 7138",
    transform: "translate(34.364 11.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11866",
    "data-name": "Path 11866",
    d: "M231.958,257.053a2.154,2.154,0,0,0-.6,1.1,1.291,1.291,0,0,0,.4,1.177,1.353,1.353,0,0,0,2.311-.929,1.317,1.317,0,0,0-.526-1.133,2.248,2.248,0,0,0-1.192-.388c-.007-.022.11-.088.358-.11a1.6,1.6,0,0,1,.994.278,1.566,1.566,0,0,1,.717,1.367,1.684,1.684,0,0,1-2.9,1.163,1.584,1.584,0,0,1-.424-1.484,1.606,1.606,0,0,1,.526-.885C231.819,257.061,231.95,257.032,231.958,257.053Z",
    transform: "translate(-231.054 -256.764)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7139",
    "data-name": "Group 7139",
    transform: "translate(40.172 7.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11867",
    "data-name": "Path 11867",
    d: "M240.827,256.582c-.037.037-.3-.161-.673-.541a3.456,3.456,0,0,1-.907-3.919c.168-.5.322-.8.366-.782s-.007.336-.1.848a4.844,4.844,0,0,0-.066,1.952,4.962,4.962,0,0,0,.921,1.726C240.666,256.283,240.864,256.546,240.827,256.582Z",
    transform: "translate(-238.997 -251.339)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7140",
    "data-name": "Group 7140",
    transform: "translate(41.78 7.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11868",
    "data-name": "Path 11868",
    d: "M243.005,255.39c-.029.037-.292-.132-.636-.49a4.315,4.315,0,0,1-.958-1.682,4.381,4.381,0,0,1-.037-2.7c.132,0,.022,1.221.4,2.588A10.758,10.758,0,0,0,243.005,255.39Z",
    transform: "translate(-241.197 -250.52)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7141",
    "data-name": "Group 7141",
    transform: "translate(61.528 0.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11869",
    "data-name": "Path 11869",
    d: "M270.512,247.08c-.058,0-.08-.344-.132-.877a7.19,7.19,0,0,0-.461-2.011,5.743,5.743,0,0,0-1.141-1.7c-.366-.395-.607-.636-.57-.68s.329.132.753.49a4.684,4.684,0,0,1,1.3,1.755,5.251,5.251,0,0,1,.373,2.15A1.786,1.786,0,0,1,270.512,247.08Z",
    transform: "translate(-268.205 -241.803)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7142",
    "data-name": "Group 7142",
    transform: "translate(64.712 0.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11870",
    "data-name": "Path 11870",
    d: "M274.139,246.936c-.051-.007-.066-.344-.059-.877a7.023,7.023,0,0,0-.168-2.018,8.664,8.664,0,0,0-.951-1.8c-.278-.453-.439-.753-.395-.782s.278.212.614.629a6.018,6.018,0,0,1,1.1,1.843,5.2,5.2,0,0,1,.073,2.15C274.271,246.614,274.191,246.936,274.139,246.936Z",
    transform: "translate(-272.56 -241.457)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7143",
    "data-name": "Group 7143",
    transform: "translate(33.948 6.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11871",
    "data-name": "Path 11871",
    d: "M230.489,332.291a3.417,3.417,0,0,1,.344-.855c.256-.548.651-1.338,1.17-2.362,1.038-2.04,2.574-4.972,4.489-8.584,3.831-7.224,9.184-17.175,15.135-28.136l4.35-8a35.454,35.454,0,0,0,3.839-22.016,35.859,35.859,0,0,0-2.7-9.242c-.468-1.038-.87-1.835-1.148-2.369-.132-.249-.234-.453-.322-.607a.8.8,0,0,1-.1-.212,1.312,1.312,0,0,1,.132.19c.088.154.2.344.351.585.3.519.724,1.3,1.214,2.34a35.016,35.016,0,0,1,2.142,23.566,35.471,35.471,0,0,1-3.093,7.926c-1.4,2.588-2.859,5.264-4.35,8.006-5.944,10.96-11.326,20.875-15.238,28.084-1.93,3.583-3.495,6.493-4.592,8.525q-.79,1.492-1.228,2.325c-.132.256-.234.453-.314.607A.835.835,0,0,1,230.489,332.291Z",
    transform: "translate(-230.486 -249.91)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7144",
    "data-name": "Group 7144",
    transform: "translate(34.858 64.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11872",
    "data-name": "Path 11872",
    d: "M273.019,328.74a2.046,2.046,0,0,1-.409.285c-.307.2-.709.446-1.214.76-1.1.68-2.618,1.616-4.482,2.764-3.78,2.332-8.986,5.586-14.682,9.279s-10.8,7.1-14.492,9.571c-1.821,1.214-3.312,2.2-4.38,2.917-.5.322-.892.578-1.2.782a2.11,2.11,0,0,1-.431.249,2.748,2.748,0,0,1,.387-.314c.3-.212.68-.49,1.163-.841,1.053-.738,2.523-1.762,4.314-3.02,3.656-2.53,8.745-5.974,14.441-9.666s10.931-6.91,14.748-9.184c1.908-1.141,3.466-2.047,4.541-2.661.512-.292.929-.519,1.25-.7A2.913,2.913,0,0,1,273.019,328.74Z",
    transform: "translate(-231.73 -328.739)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7145",
    "data-name": "Group 7145",
    transform: "translate(73.125 58.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11873",
    "data-name": "Path 11873",
    d: "M293,339.43a3.975,3.975,0,0,1-.351-.76c-.249-.563-.556-1.258-.914-2.076-.79-1.748-1.916-4.146-3.173-6.785-1.243-2.6-2.362-4.957-3.232-6.771-.38-.812-.695-1.5-.958-2.062a3.824,3.824,0,0,1-.307-.775,3.67,3.67,0,0,1,.439.709c.263.468.622,1.155,1.068,2.011.885,1.7,2.069,4.08,3.334,6.727s2.354,5.067,3.078,6.844c.366.892.636,1.623.8,2.128A3.8,3.8,0,0,1,293,339.43Z",
    transform: "translate(-284.066 -320.199)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7146",
    "data-name": "Group 7146",
    transform: "translate(33.951 63.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11874",
    "data-name": "Path 11874",
    d: "M230.49,353.294c-.066-.08,6.4-5.8,14.448-12.774s14.631-12.562,14.7-12.481-6.4,5.8-14.448,12.774S230.563,353.375,230.49,353.294Z",
    transform: "translate(-230.489 -328.039)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7147",
    "data-name": "Group 7147",
    transform: "translate(25.936 88.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11875",
    "data-name": "Path 11875",
    d: "M219.53,375.845a9.147,9.147,0,0,0,1.557-1.733c.782-1.214,1.74-3,2.822-4.935s2-3.736,2.669-5.038a15.48,15.48,0,0,1,1.141-2.069,13.147,13.147,0,0,1-.9,2.194c-.614,1.331-1.506,3.144-2.581,5.1a55.366,55.366,0,0,1-2.939,4.906,5.975,5.975,0,0,1-1.214,1.265A1.581,1.581,0,0,1,219.53,375.845Z",
    transform: "translate(-219.528 -362.069)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7148",
    "data-name": "Group 7148",
    transform: "translate(32.783 88.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11876",
    "data-name": "Path 11876",
    d: "M228.9,378.049c-.058-.029.358-.826.819-2.2a28.681,28.681,0,0,0,1.184-5.513,20.252,20.252,0,0,0-.029-5.615,5.868,5.868,0,0,0-.49-1.609c-.2-.336-.344-.512-.322-.541a1.738,1.738,0,0,1,.446.461,4.972,4.972,0,0,1,.629,1.631,17.741,17.741,0,0,1,.139,5.71,23.857,23.857,0,0,1-1.309,5.557,11.774,11.774,0,0,1-.724,1.579C229.044,377.873,228.92,378.063,228.9,378.049Z",
    transform: "translate(-228.892 -362.569)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7149",
    "data-name": "Group 7149",
    transform: "translate(24.87 88.983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11877",
    "data-name": "Path 11877",
    d: "M218.07,366.943a7.245,7.245,0,0,1,1.426-.461,23.331,23.331,0,0,0,3.371-1.206,33.933,33.933,0,0,0,4.285-2.7,4.823,4.823,0,0,1-1.06,1.075,13.983,13.983,0,0,1-3.064,1.974,16.349,16.349,0,0,1-3.466,1.119A5.612,5.612,0,0,1,218.07,366.943Z",
    transform: "translate(-218.07 -362.573)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7150",
    "data-name": "Group 7150",
    transform: "translate(13.841 40.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11878",
    "data-name": "Path 11878",
    d: "M223.688,295.89c.007.007-.029.059-.1.154-.088.117-.19.256-.322.431-.285.38-.695.936-1.185,1.689a37.913,37.913,0,0,0-3.466,6.741,86.7,86.7,0,0,0-3.341,10.748,105.022,105.022,0,0,1-4.029,13.234c-1.894,4.548-4.219,8.613-5.718,12.576a30.908,30.908,0,0,0-2.281,10.931,18.585,18.585,0,0,0,.49,4.27,17.245,17.245,0,0,0,1.046,3.078,18.11,18.11,0,0,0,.943,1.835c.11.19.19.344.263.468s.088.161.08.168a.59.59,0,0,1-.11-.146c-.08-.117-.175-.271-.3-.453a14.374,14.374,0,0,1-1.009-1.813,17.232,17.232,0,0,1-1.111-3.093,18.71,18.71,0,0,1-.548-4.321,30.521,30.521,0,0,1,2.223-11.055c1.5-4,3.817-8.087,5.7-12.6a107.952,107.952,0,0,0,4.043-13.176,83.979,83.979,0,0,1,3.437-10.763,35.517,35.517,0,0,1,3.59-6.719c.512-.738.943-1.294,1.25-1.652.139-.168.256-.3.351-.409C223.637,295.934,223.681,295.882,223.688,295.89Z",
    transform: "translate(-202.986 -295.889)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7151",
    "data-name": "Group 7151",
    transform: "translate(33.422 17.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11879",
    "data-name": "Path 11879",
    d: "M232.116,264.33a7.825,7.825,0,0,1-.38.892,10.134,10.134,0,0,0-.717,2.515,11.905,11.905,0,0,0,.139,3.861c.219,1.455.826,2.954,1.236,4.636a7.651,7.651,0,0,1,.219,2.53,15.831,15.831,0,0,1-.373,2.318,34.843,34.843,0,0,1-1.133,3.78c-.373,1.06-.7,1.9-.936,2.486a4.619,4.619,0,0,1-.4.892,4.949,4.949,0,0,1,.256-.943c.219-.665.49-1.514.819-2.515.336-1.068.731-2.332,1.046-3.773a9.86,9.86,0,0,0,.132-4.68c-.395-1.631-1.009-3.181-1.214-4.665a11.717,11.717,0,0,1-.059-3.963,9.157,9.157,0,0,1,.848-2.53c.146-.278.271-.49.358-.629S232.1,264.323,232.116,264.33Z",
    transform: "translate(-229.765 -264.329)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7152",
    "data-name": "Group 7152",
    transform: "translate(36.661 14.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11880",
    "data-name": "Path 11880",
    d: "M234.2,285.538a9.173,9.173,0,0,0,1.843-3.107,11.694,11.694,0,0,0,.578-3.875,26.8,26.8,0,0,0-.607-4.811,44.477,44.477,0,0,1-.8-4.84,18.789,18.789,0,0,1,.08-4.014,10.821,10.821,0,0,1,.643-2.632,4.93,4.93,0,0,1,.314-.665c.08-.146.132-.219.139-.212.029.015-.124.329-.314.936a12.968,12.968,0,0,0-.512,2.61,19.818,19.818,0,0,0,.007,3.956c.139,1.484.5,3.093.834,4.8a25.79,25.79,0,0,1,.585,4.877,11.369,11.369,0,0,1-.673,3.97,7.586,7.586,0,0,1-1.36,2.347,5.549,5.549,0,0,1-.526.519A1.1,1.1,0,0,1,234.2,285.538Z",
    transform: "translate(-234.196 -261.379)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7153",
    "data-name": "Group 7153",
    transform: "translate(33.878 33.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11881",
    "data-name": "Path 11881",
    d: "M251.718,286.533a4.056,4.056,0,0,1-.885.161c-.57.073-1.4.2-2.406.38a49.847,49.847,0,0,0-15.113,5.213c-.907.483-1.63.892-2.128,1.185a4.318,4.318,0,0,1-.8.417,4.136,4.136,0,0,1,.717-.541c.475-.329,1.185-.775,2.077-1.294a42.868,42.868,0,0,1,15.2-5.242c1.024-.146,1.857-.227,2.435-.263A3.681,3.681,0,0,1,251.718,286.533Z",
    transform: "translate(-230.389 -286.515)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7154",
    "data-name": "Group 7154",
    transform: "translate(40.054 25.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11882",
    "data-name": "Path 11882",
    d: "M255.181,275.606c0,.073-1.082.051-2.786.322a20.8,20.8,0,0,0-2.947.687,22.5,22.5,0,0,0-3.415,1.418,22.779,22.779,0,0,0-3.107,2,20.724,20.724,0,0,0-2.245,2.033c-1.185,1.25-1.784,2.15-1.843,2.106a3.022,3.022,0,0,1,.38-.658,13.086,13.086,0,0,1,1.265-1.638,17.477,17.477,0,0,1,2.223-2.12,19.193,19.193,0,0,1,6.639-3.48,18.15,18.15,0,0,1,3.012-.622,13.462,13.462,0,0,1,2.062-.11A3.341,3.341,0,0,1,255.181,275.606Z",
    transform: "translate(-238.837 -275.541)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7155",
    "data-name": "Group 7155",
    transform: "translate(38.082 42.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11883",
    "data-name": "Path 11883",
    d: "M256.086,298.508a3.9,3.9,0,0,1-.826.314c-.534.176-1.309.439-2.259.775a66.394,66.394,0,0,0-14.112,6.953c-.848.548-1.528,1-2,1.323a3.994,3.994,0,0,1-.753.461,3.738,3.738,0,0,1,.665-.578c.439-.358,1.1-.848,1.93-1.426a53.883,53.883,0,0,1,14.17-6.983c.965-.307,1.755-.534,2.311-.665A3.651,3.651,0,0,1,256.086,298.508Z",
    transform: "translate(-236.139 -298.501)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7156",
    "data-name": "Group 7156",
    transform: "translate(69.201 20.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11884",
    "data-name": "Path 11884",
    d: "M290.582,271.267a4.659,4.659,0,0,1-.7-.249c-.453-.168-1.119-.424-1.974-.709a37.162,37.162,0,0,0-7.3-1.6l.183-.168c.08,3.144.066,6.888-.219,10.865a89.359,89.359,0,0,1-1.543,11.56l-.007-.08a57.247,57.247,0,0,0,2.427,6.493c.344.76.658,1.331.878,1.726a3.87,3.87,0,0,1,.336.6,3.181,3.181,0,0,1-.417-.548,16.477,16.477,0,0,1-.958-1.7,47.678,47.678,0,0,1-2.566-6.478l-.015-.037.007-.044a98.247,98.247,0,0,0,1.477-11.523c.278-3.97.322-7.7.271-10.836v-.19l.19.022a34.249,34.249,0,0,1,7.326,1.747c.855.314,1.514.592,1.952.8A5.5,5.5,0,0,1,290.582,271.267Z",
    transform: "translate(-278.7 -268.35)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7157",
    "data-name": "Group 7157",
    transform: "translate(71.146 23.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11885",
    "data-name": "Path 11885",
    d: "M291.889,275.7a8.577,8.577,0,0,1-1.535-.417c-.936-.285-2.245-.643-3.7-.987-2.917-.68-5.308-1.119-5.294-1.236a6.425,6.425,0,0,1,1.594.139c.973.139,2.318.38,3.788.724A18.458,18.458,0,0,1,291.889,275.7Z",
    transform: "translate(-281.36 -273.043)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7158",
    "data-name": "Group 7158",
    transform: "translate(62.109 12.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11886",
    "data-name": "Path 11886",
    d: "M285.057,260.579a22.822,22.822,0,0,1-2.318-.541,38.8,38.8,0,0,0-5.645-.9,45.424,45.424,0,0,0-5.718-.08,19.113,19.113,0,0,1-2.376.088,2.163,2.163,0,0,1,.629-.146c.409-.073,1-.146,1.733-.212a33.669,33.669,0,0,1,5.769-.037,31.094,31.094,0,0,1,5.681,1.016c.709.2,1.28.388,1.667.534A2.329,2.329,0,0,1,285.057,260.579Z",
    transform: "translate(-269 -258.645)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7159",
    "data-name": "Group 7159",
    transform: "translate(43.775 11.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11887",
    "data-name": "Path 11887",
    d: "M263.436,263.219a4.934,4.934,0,0,1-.965.307c-.629.161-1.557.373-2.705.57a36.736,36.736,0,0,1-9.11.453,11.307,11.307,0,0,1-4.9-1.228,4.2,4.2,0,0,1-1.521-1.652,3.169,3.169,0,0,1-.263-1.938,10.15,10.15,0,0,1,.819-2.654,2.894,2.894,0,0,1,.519-.877c.022.015-.154.329-.38.936a11.928,11.928,0,0,0-.687,2.632,2.94,2.94,0,0,0,.278,1.769,3.926,3.926,0,0,0,1.426,1.5,11.345,11.345,0,0,0,4.745,1.148,40.906,40.906,0,0,0,9.03-.344c1.148-.161,2.077-.336,2.713-.453A4.879,4.879,0,0,1,263.436,263.219Z",
    transform: "translate(-243.925 -256.199)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7253",
    "data-name": "Group 7253",
    transform: "translate(24.282 33.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7248",
    "data-name": "Group 7248",
    transform: "translate(8.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11888",
    "data-name": "Path 11888",
    d: "M254.821,84.465c-3.5-7.575-12.145-6.083-16.283-4.073a18.24,18.24,0,0,0-9.147,9.688c-1.221,2.925-2.186,6.259-4.636,8.028a36.524,36.524,0,0,1-3.48,1.813A4.5,4.5,0,0,0,218.847,103c-.366,2.515,2.164,4.263,4.3,5.279-1.272.863-1.6,2.815-1.155,4.38a11.162,11.162,0,0,0,2.5,4.021,62.431,62.431,0,0,0,12.686,10.7c3.992,2.486,6.573,2.778,10.865.994,1.74-.724,3.363-1.916,5.221-2.128,2.157-.249,4.226.863,6.354,1.309s4.826-.168,5.52-2.413a16.556,16.556,0,0,0,.292-2.705c.117-.9.556-1.879,1.367-2.084a3.708,3.708,0,0,1,1.967.446c1.543.512,3.868,11.962,5.345,11.267,0,0,2.15-19.405-2-30.76-1.323-3.619-4.138-11.348-6.4-14.353-3.093-4.138-10.522-3.224-10.894-2.493",
    transform: "translate(-218.811 -78.766)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7247",
    "data-name": "Group 7247",
    transform: "translate(12.64 4.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7246",
    "data-name": "Group 7246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11889",
    "data-name": "Path 11889",
    d: "M255.037,88.107c-5.5-1.923-12.927,2.3-14.616,7.882-1.872,6.2-3.919,13.841-4.27,18.7-.717,9.79,6.237,12.686,6.237,12.686l-2.83,15.3,23.866-7.714,8.328-36.054.775-3.034Z",
    transform: "translate(-236.099 -85.677)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7174",
    "data-name": "Group 7174",
    transform: "translate(4.317 17.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7173",
    "data-name": "Group 7173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7172",
    "data-name": "Group 7172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7171",
    "data-name": "Group 7171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7170",
    "data-name": "Group 7170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7169",
    "data-name": "Group 7169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7168",
    "data-name": "Group 7168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7167",
    "data-name": "Group 7167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7166",
    "data-name": "Group 7166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7165",
    "data-name": "Group 7165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7164",
    "data-name": "Group 7164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7163",
    "data-name": "Group 7163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7162",
    "data-name": "Group 7162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11890",
    "data-name": "Path 11890",
    d: "M242.008,109.171c.088.2,1.214-.1,2.457.395s1.908,1.477,2.106,1.375c.1-.044.051-.373-.234-.819a3.4,3.4,0,0,0-1.616-1.287,3.271,3.271,0,0,0-2.033-.124C242.2,108.857,241.964,109.076,242.008,109.171Z",
    transform: "translate(-242.003 -108.604)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7187",
    "data-name": "Group 7187",
    transform: "translate(16.649 19.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7186",
    "data-name": "Group 7186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7185",
    "data-name": "Group 7185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7184",
    "data-name": "Group 7184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7183",
    "data-name": "Group 7183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7182",
    "data-name": "Group 7182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7181",
    "data-name": "Group 7181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7180",
    "data-name": "Group 7180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7179",
    "data-name": "Group 7179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7178",
    "data-name": "Group 7178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7177",
    "data-name": "Group 7177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7176",
    "data-name": "Group 7176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7175",
    "data-name": "Group 7175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11891",
    "data-name": "Path 11891",
    d: "M258.885,113.408c.146.175,1.133-.461,2.464-.366,1.338.073,2.267.826,2.428.673.073-.066-.058-.373-.468-.709a3.423,3.423,0,0,0-1.923-.738,3.282,3.282,0,0,0-1.974.49C258.972,113.043,258.819,113.328,258.885,113.408Z",
    transform: "translate(-258.87 -112.261)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7199",
    "data-name": "Group 7199",
    transform: "translate(7.987 15.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7198",
    "data-name": "Group 7198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7197",
    "data-name": "Group 7197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7196",
    "data-name": "Group 7196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7195",
    "data-name": "Group 7195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7194",
    "data-name": "Group 7194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7193",
    "data-name": "Group 7193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7192",
    "data-name": "Group 7192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7191",
    "data-name": "Group 7191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7190",
    "data-name": "Group 7190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7189",
    "data-name": "Group 7189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7188",
    "data-name": "Group 7188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11892",
    "data-name": "Path 11892",
    d: "M250.157,117.381a8.865,8.865,0,0,0-2.025-.877c-.322-.11-.621-.256-.629-.49a1.785,1.785,0,0,1,.453-.936c.5-.731,1.024-1.5,1.579-2.3a44.486,44.486,0,0,0,3.766-6.105,44.944,44.944,0,0,0-4.248,5.791c-.534.812-1.053,1.587-1.543,2.325a2,2,0,0,0-.483,1.265.858.858,0,0,0,.431.614,2.387,2.387,0,0,0,.548.212A8.735,8.735,0,0,0,250.157,117.381Z",
    transform: "translate(-247.023 -106.667)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7210",
    "data-name": "Group 7210",
    transform: "translate(5.843 41.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7209",
    "data-name": "Group 7209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7208",
    "data-name": "Group 7208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7207",
    "data-name": "Group 7207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7206",
    "data-name": "Group 7206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7205",
    "data-name": "Group 7205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7204",
    "data-name": "Group 7204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7203",
    "data-name": "Group 7203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7202",
    "data-name": "Group 7202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7201",
    "data-name": "Group 7201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7200",
    "data-name": "Group 7200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11893",
    "data-name": "Path 11893",
    d: "M244.529,141.9a25.624,25.624,0,0,0,13.761-.351s-4.636,5.893-14.2,2.735Z",
    transform: "translate(-244.09 -141.55)",
    fill: "#eb996e"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7211",
    "data-name": "Group 7211",
    transform: "translate(10.338 28.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11894",
    "data-name": "Path 11894",
    d: "M250.324,127.284c-.124-.161.059.2,0,0Z",
    transform: "translate(-250.249 -125.219)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11895",
    "data-name": "Path 11895",
    d: "M254.561,125.9a2.429,2.429,0,0,0-1.44-1.272,2.672,2.672,0,0,0-2.574.424,1.652,1.652,0,0,0-.227,1.492c.461.585.5,1.089,1.148,1.448a3.4,3.4,0,0,0,2.808-.322A1.576,1.576,0,0,0,254.561,125.9Z",
    transform: "translate(-250.238 -124.476)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7223",
    "data-name": "Group 7223",
    transform: "translate(9.787 28.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7222",
    "data-name": "Group 7222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7221",
    "data-name": "Group 7221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7220",
    "data-name": "Group 7220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7219",
    "data-name": "Group 7219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7218",
    "data-name": "Group 7218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7217",
    "data-name": "Group 7217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7216",
    "data-name": "Group 7216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7215",
    "data-name": "Group 7215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7214",
    "data-name": "Group 7214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7213",
    "data-name": "Group 7213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7212",
    "data-name": "Group 7212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11896",
    "data-name": "Path 11896",
    d: "M254.446,123.779c-.212-.058-.541,1.353-1.989,2.069s-2.917.212-2.969.4c-.044.08.271.351.907.519a3.625,3.625,0,0,0,2.464-.256,3.171,3.171,0,0,0,1.579-1.755C254.621,124.181,254.541,123.794,254.446,123.779Z",
    transform: "translate(-249.484 -123.778)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7231",
    "data-name": "Group 7231",
    transform: "translate(19.351 13.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7230",
    "data-name": "Group 7230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7229",
    "data-name": "Group 7229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7228",
    "data-name": "Group 7228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7227",
    "data-name": "Group 7227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7226",
    "data-name": "Group 7226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7225",
    "data-name": "Group 7225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7224",
    "data-name": "Group 7224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11897",
    "data-name": "Path 11897",
    d: "M262.569,104.294c-.073.373,1.024.76,2.12,1.557,1.119.775,1.857,1.689,2.172,1.484.146-.1.139-.49-.088-1.009a4.02,4.02,0,0,0-1.338-1.609,3.787,3.787,0,0,0-1.93-.709C262.956,103.987,262.605,104.119,262.569,104.294Z",
    transform: "translate(-262.565 -104.007)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7239",
    "data-name": "Group 7239",
    transform: "translate(5.066 11.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7238",
    "data-name": "Group 7238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7237",
    "data-name": "Group 7237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7236",
    "data-name": "Group 7236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7235",
    "data-name": "Group 7235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7234",
    "data-name": "Group 7234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7233",
    "data-name": "Group 7233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7232",
    "data-name": "Group 7232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11898",
    "data-name": "Path 11898",
    d: "M243.081,101.922c.292.278,1.287-.132,2.523-.271,1.228-.168,2.3-.015,2.508-.358.088-.161-.1-.453-.585-.695a3.838,3.838,0,0,0-2.1-.3,3.72,3.72,0,0,0-1.952.8C243.059,101.461,242.949,101.783,243.081,101.922Z",
    transform: "translate(-243.028 -100.267)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11899",
    "data-name": "Path 11899",
    d: "M280.847,95.777a3.72,3.72,0,0,0-1.828-1.623,122.617,122.617,0,0,0-14.711-6.844l-2.077,1.177a10.306,10.306,0,0,0,5.045,10.295c1.419.79,3.261,1.535,3.444,3.144.19,1.674-1.565,2.815-2.552,4.175a5.265,5.265,0,0,0-.161,5.827c.636.987,1.6,1.733,2.186,2.757a5.228,5.228,0,0,1,.2,4.5c-.592,1.44-1.579,3.385-2.9,4.2a8.935,8.935,0,0,0,9.571-4.036c1.1-1.886,1.192-4.175,1.345-6.354a81.7,81.7,0,0,1,2.362-14.74A3.974,3.974,0,0,0,280.847,95.777Z",
    transform: "translate(-243.096 -85.59)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7245",
    "data-name": "Group 7245",
    transform: "translate(0.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7244",
    "data-name": "Group 7244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7243",
    "data-name": "Group 7243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7242",
    "data-name": "Group 7242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7241",
    "data-name": "Group 7241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7240",
    "data-name": "Group 7240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11900",
    "data-name": "Path 11900",
    d: "M257.92,86.9a20.4,20.4,0,0,1-4.563,4.38,6.887,6.887,0,0,1-6.061.855l1.477-1.631a30.556,30.556,0,0,1-11.633,4.811c2.618-3.181,5.316-6.434,8.891-8.489s8.262-2.683,11.75-.5",
    transform: "translate(-237.14 -84.957)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11901",
    "data-name": "Path 11901",
    d: "M281.146,112.9,270,121.557c1.28,1.389.775,4.95-.475,6.361s-2.925,2.618-3.415,4.438c-.541,2,.519,4.065.548,6.135.044,2.932-1.93,5.44-3.444,7.941s-2.61,5.842-.921,8.233c1.908,2.691,6.23,2.3,8.84.292s4.1-5.111,6.04-7.78,4.965-4.7,8.248-4.365A63.027,63.027,0,0,0,281.146,112.9Z",
    transform: "translate(-221.956 -87.942)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7249",
    "data-name": "Group 7249",
    transform: "translate(41.528 10.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11902",
    "data-name": "Path 11902",
    d: "M283.761,131.562c-.066-.124.592-.6,1.718-1.5a22.392,22.392,0,0,0,4.212-4.277,14.329,14.329,0,0,0,1.886-3.568,11.408,11.408,0,0,0,.658-4.475,10.1,10.1,0,0,0-1.535-4.665,15.859,15.859,0,0,0-3.7-3.992c-3.005-2.332-6.551-3.67-9.71-5.045a35.011,35.011,0,0,1-8.175-4.489,14.91,14.91,0,0,1-4.16-4.789c-.68-1.353-.79-2.186-.687-2.223.139-.051.49.68,1.316,1.835a17.252,17.252,0,0,0,4.329,4.095,38.944,38.944,0,0,0,8.05,3.956c1.6.636,3.3,1.294,5.038,2.106a25.9,25.9,0,0,1,5.169,3.064,16.835,16.835,0,0,1,4.124,4.526,11.718,11.718,0,0,1,1.7,5.55,12.5,12.5,0,0,1-.936,5.118,14.483,14.483,0,0,1-2.3,3.839,18.014,18.014,0,0,1-4.855,4.065C284.6,131.408,283.819,131.664,283.761,131.562Z",
    transform: "translate(-264.235 -92.537)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7250",
    "data-name": "Group 7250",
    transform: "translate(43.923 5.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11903",
    "data-name": "Path 11903",
    d: "M284.853,103.686a5.39,5.39,0,0,1-.972-.314c-.614-.227-1.5-.57-2.581-1.024a32.505,32.505,0,0,1-7.962-4.533,16.283,16.283,0,0,1-5.294-7.429,11.154,11.154,0,0,1-.519-2.742,5.163,5.163,0,0,1,0-.76c.007-.175.015-.263.029-.263A16.34,16.34,0,0,0,268.3,90.3a16.6,16.6,0,0,0,5.279,7.217,36.37,36.37,0,0,0,7.831,4.584c1.016.453,1.864.834,2.53,1.133A5.7,5.7,0,0,1,284.853,103.686Z",
    transform: "translate(-267.51 -86.62)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7251",
    "data-name": "Group 7251",
    transform: "translate(43.014 8.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11904",
    "data-name": "Path 11904",
    d: "M284.87,115.89c-.044-.015.183-.439.3-1.265a6.221,6.221,0,0,0-.592-3.415,9.792,9.792,0,0,0-3.378-3.89c-1.6-1.163-3.59-2.084-5.579-3.268a19.875,19.875,0,0,1-4.979-4.2,20.343,20.343,0,0,1-2.9-4.46,18.3,18.3,0,0,1-1.221-3.371c-.117-.409-.161-.731-.2-.951a1.925,1.925,0,0,1-.044-.336,11.654,11.654,0,0,1,.388,1.25,21.349,21.349,0,0,0,1.316,3.3,20.987,20.987,0,0,0,2.925,4.35,20.263,20.263,0,0,0,4.914,4.109c1.96,1.17,3.963,2.113,5.586,3.312a9.93,9.93,0,0,1,3.422,4.065,6.089,6.089,0,0,1,.49,3.546,4.009,4.009,0,0,1-.285.936C284.936,115.795,284.885,115.9,284.87,115.89Z",
    transform: "translate(-266.267 -90.73)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7252",
    "data-name": "Group 7252",
    transform: "translate(0 2.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11905",
    "data-name": "Path 11905",
    d: "M207.439,106.336c-.007-.007.015-.044.066-.117a2.241,2.241,0,0,1,.241-.322,3.3,3.3,0,0,1,1.243-.921,7.374,7.374,0,0,1,2.413-.417c.943-.058,2.025-.124,3.217-.124a17.477,17.477,0,0,0,3.839-.351,9.428,9.428,0,0,0,3.853-2.033,17.112,17.112,0,0,0,3.144-3.722,49.836,49.836,0,0,0,2.508-4.65,37.345,37.345,0,0,1,2.625-4.636,14.317,14.317,0,0,1,3.451-3.59,14.489,14.489,0,0,1,7.933-2.6,13.768,13.768,0,0,1,5.564.98c.3.132.57.256.812.358l.57.322a2.326,2.326,0,0,1,.453.285,2.625,2.625,0,0,1-.49-.219c-.168-.08-.358-.175-.578-.285-.241-.1-.519-.2-.819-.329a14.016,14.016,0,0,0-5.5-.848,14.307,14.307,0,0,0-7.736,2.61,13.879,13.879,0,0,0-3.349,3.517,39.567,39.567,0,0,0-2.6,4.6,49,49,0,0,1-2.537,4.68,17.246,17.246,0,0,1-3.232,3.795,9.708,9.708,0,0,1-4.007,2.069,16.9,16.9,0,0,1-3.912.314c-1.192-.015-2.259.037-3.21.073a7.334,7.334,0,0,0-2.362.344,3.362,3.362,0,0,0-1.243.834A5.078,5.078,0,0,1,207.439,106.336Z",
    transform: "translate(-207.438 -82.853)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7257",
    "data-name": "Group 7257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11906",
    "data-name": "Path 11906",
    d: "M194.048,90.407c-4.394-11.077-10.207-21.935-11.041-30.2l-8.738.358c.19,3.2,1.331,29.788,7.524,40.3s26.871,35.1,26.871,35.1l7.275-18.711S198.443,101.492,194.048,90.407Z",
    transform: "translate(-174.24 -40.344)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11907",
    "data-name": "Path 11907",
    d: "M179.994,36.7H176.17s.373,2.252,2.106,2.376,1.4-.263,1.4-.263l-.387.351-2.384.475s.124,1.857,1.7,2.15l2.311-2.15Z",
    transform: "translate(-174.751 -34.023)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11908",
    "data-name": "Path 11908",
    d: "M189.943,35.38a14.873,14.873,0,0,1-.387,2.7l-3.5,2.881-.892-4.248a1.307,1.307,0,0,0-1.2-1.038l-1.594-.1S183,33.362,181,33.559c0,0-1.1-.3-1.981,3.378-.965,4.007-5.133,13.439-4.767,16.6l8.862.351c-.1-2.939,2.325-6.047,3.51-7.392a3.166,3.166,0,0,0,.738-1.411,4.428,4.428,0,0,1,.994-1.945c1.089-1.214,3.4-3.4,3.4-3.4V33.062C191.763,33.076,190.279,32.6,189.943,35.38Zm-7.122,6.449L181,42.655l.307-1.857,1.514-.146Z",
    transform: "translate(-174.229 -33.039)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7254",
    "data-name": "Group 7254",
    transform: "translate(3.11 0.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11909",
    "data-name": "Path 11909",
    d: "M182.063,42.958a2.956,2.956,0,0,1,.088-.782c.08-.5.212-1.221.38-2.106.183-.921.388-1.967.614-3.122a12.51,12.51,0,0,0,.3-1.813c.015-.592-.219-1.28-.855-1.316-.6-.11-1.1.395-1.411.914a3.634,3.634,0,0,0-.351.848c-.1.292-.19.585-.285.87-.351,1.119-.673,2.142-.951,3.034-.285.863-.548,1.55-.746,2.018a2.53,2.53,0,0,1-.358.7,3.429,3.429,0,0,1,.219-.753c.161-.483.38-1.177.629-2.04.256-.9.548-1.93.87-3.056.088-.285.183-.578.278-.877a4.2,4.2,0,0,1,.373-.921,2.865,2.865,0,0,1,.687-.812,1.426,1.426,0,0,1,1.1-.292,1.34,1.34,0,0,1,.556.2,1.205,1.205,0,0,1,.395.446,2.089,2.089,0,0,1,.219,1.053,12.363,12.363,0,0,1-.329,1.879c-.256,1.141-.49,2.186-.695,3.1-.2.885-.373,1.594-.5,2.084A2.7,2.7,0,0,1,182.063,42.958Z",
    transform: "translate(-178.483 -33.433)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7255",
    "data-name": "Group 7255",
    transform: "translate(7.626 4.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11910",
    "data-name": "Path 11910",
    d: "M185.537,43.679a14.182,14.182,0,0,1-.1-2.15c-.022-.292-.044-.57-.073-.826s-.051-.439-.168-.534c-.249-.183-.548-.19-.534-.256q0-.044.175-.066a.818.818,0,0,1,.512.1.935.935,0,0,1,.358.7c.044.263.08.548.1.855A4.134,4.134,0,0,1,185.537,43.679Z",
    transform: "translate(-184.659 -39.841)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7256",
    "data-name": "Group 7256",
    transform: "translate(6.581 7.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11911",
    "data-name": "Path 11911",
    d: "M189.5,42.858c.029.044-.241.322-.717.738a8.84,8.84,0,0,1-2.084,1.375,7.134,7.134,0,0,1-2.435.578,2.524,2.524,0,0,1-1.031-.029,3.119,3.119,0,0,1,.994-.241,9.427,9.427,0,0,0,2.311-.658,14.089,14.089,0,0,0,2.077-1.243C189.131,43.026,189.46,42.814,189.5,42.858Z",
    transform: "translate(-183.23 -42.852)",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7263",
    "data-name": "Group 7263",
    transform: "translate(77.673 62.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11912",
    "data-name": "Path 11912",
    d: "M285.118,150.838s9.834-.292,15.735-2.04,28.545-7.144,28.545-7.144l36.288-6.054.717,9.4s-33.729,9.864-40.28,12.108-36.5,12.518-42.152,11.216l-3.51-7.217Z",
    transform: "translate(-280.46 -123.338)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7262",
    "data-name": "Group 7262",
    transform: "translate(84.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11913",
    "data-name": "Path 11913",
    d: "M414.093,120.051c-.592-.132-3.532,1.206-3.532,1.206a1.966,1.966,0,0,0,.058-2.428l-4.036,1.981a40.673,40.673,0,0,1-3.371,3.056,45.748,45.748,0,0,0-5.147,5.564l-2.406,2.245,1.492,8.884a7.441,7.441,0,0,0,3.159-.417,13.211,13.211,0,0,0,3.071-2.91l3.444-.292a1.93,1.93,0,0,0,1.1-.431,2.867,2.867,0,0,0,.855-2.347c2.157-1.243.914-2.822.914-2.822a2.71,2.71,0,0,0,1.769-.98,1.646,1.646,0,0,0-.11-1.93c-.417-.746-3.568-.5-3.568-.5l-.168-.914s4.826-3.831,5.9-4.665S414.649,120.175,414.093,120.051Z",
    transform: "translate(-395.66 -118.83)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7258",
    "data-name": "Group 7258",
    transform: "translate(6.067 2.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11914",
    "data-name": "Path 11914",
    d: "M412.85,122.03a5.233,5.233,0,0,1-1.484,1.769,17.458,17.458,0,0,0-1.77,1.726,7.324,7.324,0,0,0-1.287,2.669,14.626,14.626,0,0,1-1.089,2.888,10.052,10.052,0,0,1-1.462,2.062,8.946,8.946,0,0,1-1.265,1.133,1.624,1.624,0,0,1-.534.314c-.044-.051.687-.556,1.6-1.63a11.211,11.211,0,0,0,1.36-2.04,16.206,16.206,0,0,0,1.038-2.837,7.3,7.3,0,0,1,1.382-2.778,15.6,15.6,0,0,1,1.857-1.7A19.946,19.946,0,0,0,412.85,122.03Z",
    transform: "translate(-403.957 -122.029)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7259",
    "data-name": "Group 7259",
    transform: "translate(6.644 12.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11915",
    "data-name": "Path 11915",
    d: "M411.286,138.834a5.361,5.361,0,0,1-1.616.76,7.671,7.671,0,0,1-1.916.395,6.894,6.894,0,0,1-1.163-.015,2.505,2.505,0,0,1-1.228-.424,1.417,1.417,0,0,1-.614-1.2,1.785,1.785,0,0,1,.651-1.067,2.109,2.109,0,0,1,.951-.534c.314-.088.607-.154.877-.2a5.236,5.236,0,0,1,1.769-.2c0,.037-.651.175-1.7.461-.263.073-.548.154-.848.249a1.832,1.832,0,0,0-.8.49,1.528,1.528,0,0,0-.512.826,1.059,1.059,0,0,0,.468.87,3.722,3.722,0,0,0,2.15.395,8.576,8.576,0,0,0,1.857-.3C410.642,139.046,411.264,138.776,411.286,138.834Z",
    transform: "translate(-404.747 -136.316)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7260",
    "data-name": "Group 7260",
    transform: "translate(9.478 9.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11916",
    "data-name": "Path 11916",
    d: "M413.264,134.7a3,3,0,0,1-1.243.373,8.017,8.017,0,0,1-1.411.1,2.163,2.163,0,0,1-1.682-.651,1.672,1.672,0,0,1-.073-1.813,2.453,2.453,0,0,1,1.075-.994,2.645,2.645,0,0,1,1.25-.358c.022.059-.461.2-1.126.592a2.287,2.287,0,0,0-.892.914,1.345,1.345,0,0,0,.059,1.411,1.878,1.878,0,0,0,1.4.534,9.163,9.163,0,0,0,1.367-.022A10.26,10.26,0,0,1,413.264,134.7Z",
    transform: "translate(-408.622 -131.346)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7261",
    "data-name": "Group 7261",
    transform: "translate(7.172 16.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11917",
    "data-name": "Path 11917",
    d: "M410.054,142.776a3.266,3.266,0,0,1-1.016.314,8.759,8.759,0,0,1-2.559.307.983.983,0,0,1-.782-.336,1.16,1.16,0,0,1-.227-.76,1.445,1.445,0,0,1,.614-1.082c.636-.388,1.111-.154,1.082-.124a2.246,2.246,0,0,0-.921.344,1.2,1.2,0,0,0-.424.877.816.816,0,0,0,.161.5.642.642,0,0,0,.519.19,12.631,12.631,0,0,0,2.486-.19A2.9,2.9,0,0,1,410.054,142.776Z",
    transform: "translate(-405.469 -140.998)",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7276",
    "data-name": "Group 7276",
    transform: "translate(28.59 75.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7264",
    "data-name": "Group 7264",
    transform: "translate(18.754 42.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11918",
    "data-name": "Path 11918",
    d: "M257.259,197.765a2.917,2.917,0,0,1-.687.395,12.359,12.359,0,0,1-2.018.768,15.248,15.248,0,0,1-7.078.344,14.889,14.889,0,0,1-6.442-2.947,13.04,13.04,0,0,1-1.572-1.477,2.915,2.915,0,0,1-.483-.629c.051-.051.768.826,2.215,1.894a15.712,15.712,0,0,0,6.354,2.786,16.107,16.107,0,0,0,6.932-.234C256.228,198.226,257.23,197.7,257.259,197.765Z",
    transform: "translate(-238.979 -194.217)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11919",
    "data-name": "Path 11919",
    d: "M233.759,155.055s23.134-7.4,24-7.626,21.263,1.587,21.263,1.587-.877,13.519,4.285,17.892h0l-15,5.411-4.738,13.022s-2.64,5.308-.541,10.288c3.97,9.425,10.865,24.3,9.842,26-.11.175-.695-5.155-10.522-7.933-2.969-.841-8.357-.848-13.234.132-20.985,4.226-29.086,13.922-31.477,15.581,0,0,4.321-33.9,2.274-39.2s-4.2-8.745-2.523-13.461,4.212-12.24,4.212-12.24l-8.262-9.381,11.553-19.208,10.565,8.759Z",
    transform: "translate(-213.33 -135.92)",
    fill: "#008e76"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7265",
    "data-name": "Group 7265",
    transform: "translate(15.007 37.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11920",
    "data-name": "Path 11920",
    d: "M246.969,200.391a3.118,3.118,0,0,1-.8.037,11.751,11.751,0,0,1-2.157-.278,13.353,13.353,0,0,1-6.3-3.312,12.522,12.522,0,0,1-3.561-6.164,10.744,10.744,0,0,1-.292-2.157,2.744,2.744,0,0,1,.037-.8,24.986,24.986,0,0,0,.512,2.881,13.023,13.023,0,0,0,3.561,5.952,13.932,13.932,0,0,0,6.105,3.32C245.835,200.333,246.969,200.318,246.969,200.391Z",
    transform: "translate(-233.855 -187.72)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7266",
    "data-name": "Group 7266",
    transform: "translate(6.39 21.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11921",
    "data-name": "Path 11921",
    d: "M222.077,165.849a9.159,9.159,0,0,1,1.221,8.27,19.727,19.727,0,0,0,.007-4.226A20.613,20.613,0,0,0,222.077,165.849Z",
    transform: "translate(-222.069 -165.847)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7267",
    "data-name": "Group 7267",
    transform: "translate(51.062 25.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11922",
    "data-name": "Path 11922",
    d: "M287.6,171.329c.037.059-.475.388-1.177,1.068a9.97,9.97,0,0,0-2.157,3.086,9.514,9.514,0,0,0-.819,3.663c-.015.972.1,1.572.029,1.587a3.959,3.959,0,0,1-.3-1.587,8.511,8.511,0,0,1,.746-3.824,8.914,8.914,0,0,1,2.325-3.129A4.032,4.032,0,0,1,287.6,171.329Z",
    transform: "translate(-283.166 -171.325)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7268",
    "data-name": "Group 7268",
    transform: "translate(16.328 43.293)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11923",
    "data-name": "Path 11923",
    d: "M244.018,201.879a10.688,10.688,0,0,1-5.791-3.276,11.713,11.713,0,0,1-2.508-3.473c-.526,2.3,2.669,6.369,5.784,7.86a11.215,11.215,0,0,0,10.032-.271A37.579,37.579,0,0,1,244.018,201.879Z",
    transform: "translate(-235.662 -195.13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7269",
    "data-name": "Group 7269",
    transform: "translate(5.652 64.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11924",
    "data-name": "Path 11924",
    d: "M268.425,226.474c-.029.037-.607-.417-1.806-.958a13.759,13.759,0,0,0-5.4-1.126,20.046,20.046,0,0,0-8.021,1.631,51.932,51.932,0,0,0-8.781,5.038,91.953,91.953,0,0,1-16.166,8.964c-2.179.929-3.978,1.594-5.228,2.033-.622.219-1.111.373-1.448.483a2.837,2.837,0,0,1-.512.139,2.424,2.424,0,0,1,.49-.212l1.418-.548c1.236-.475,3.012-1.177,5.169-2.135a99.182,99.182,0,0,0,16.057-9.037,50.582,50.582,0,0,1,8.855-5.045,20.066,20.066,0,0,1,8.16-1.572,13.4,13.4,0,0,1,5.462,1.258A8.2,8.2,0,0,1,268.425,226.474Z",
    transform: "translate(-221.06 -224.118)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7270",
    "data-name": "Group 7270",
    transform: "translate(6.734 51.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11925",
    "data-name": "Path 11925",
    d: "M264.641,209.721a12.632,12.632,0,0,0-1.389-1.082,9.74,9.74,0,0,0-4.511-1.418,15.59,15.59,0,0,0-6.917,1.272,83.731,83.731,0,0,0-7.831,3.9,73.014,73.014,0,0,1-7.919,3.817,30,30,0,0,1-6.939,1.857,19.915,19.915,0,0,1-4.848.08,12.665,12.665,0,0,1-1.3-.212,2.213,2.213,0,0,1-.446-.117c.007-.037.629.088,1.762.175a21.52,21.52,0,0,0,4.8-.2,30.956,30.956,0,0,0,6.851-1.916,77.727,77.727,0,0,0,7.867-3.831,78.211,78.211,0,0,1,7.882-3.89,15.478,15.478,0,0,1,7.07-1.214,9.488,9.488,0,0,1,4.57,1.565A5.131,5.131,0,0,1,264.641,209.721Z",
    transform: "translate(-222.54 -206.894)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7271",
    "data-name": "Group 7271",
    transform: "translate(3.567 45.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11926",
    "data-name": "Path 11926",
    d: "M232.592,198.158c.015.022-.154.154-.468.38a4.67,4.67,0,0,1-.592.38c-.241.132-.512.3-.826.439a11.963,11.963,0,0,1-2.3.812,14.243,14.243,0,0,1-2.969.38,14.511,14.511,0,0,1-2.976-.292,12.626,12.626,0,0,1-2.325-.746,8.271,8.271,0,0,1-.841-.409,5.138,5.138,0,0,1-.607-.358c-.322-.219-.49-.344-.475-.366.037-.058.753.4,2.025.892a14.436,14.436,0,0,0,2.3.651,15.652,15.652,0,0,0,2.9.256,15.254,15.254,0,0,0,2.9-.344,13.971,13.971,0,0,0,2.274-.717C231.846,198.582,232.548,198.1,232.592,198.158Z",
    transform: "translate(-218.209 -198.153)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7272",
    "data-name": "Group 7272",
    transform: "translate(16.283 41.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11927",
    "data-name": "Path 11927",
    d: "M271.639,194.851a1.488,1.488,0,0,1-.285.249,6.328,6.328,0,0,1-.914.585,9.975,9.975,0,0,1-3.831,1.1,17.468,17.468,0,0,1-5.893-.541c-2.172-.526-4.46-1.382-6.917-2.069a31.537,31.537,0,0,0-12.913-.834,32.235,32.235,0,0,0-3.875.8,14.312,14.312,0,0,1-1.411.366,1.266,1.266,0,0,1,.344-.154c.234-.08.57-.219,1.024-.358a27.075,27.075,0,0,1,3.875-.921,30.53,30.53,0,0,1,13.059.731c2.479.695,4.76,1.565,6.895,2.1a17.639,17.639,0,0,0,5.784.614,10.64,10.64,0,0,0,3.787-.965C271.208,195.143,271.617,194.814,271.639,194.851Z",
    transform: "translate(-235.6 -192.676)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7273",
    "data-name": "Group 7273",
    transform: "translate(6.632 28.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11928",
    "data-name": "Path 11928",
    d: "M267.484,179.121a2.226,2.226,0,0,1-.468.073c-.307.029-.76.088-1.345.124a25.733,25.733,0,0,1-4.965-.351c-2.077-.336-4.5-.958-7.18-1.682a54.482,54.482,0,0,0-8.789-1.821,23.012,23.012,0,0,0-2.347-.073c-.388.015-.768.007-1.148.037l-1.119.132a20.651,20.651,0,0,0-4.175,1.046c-2.6.921-4.87,1.981-6.866,2.654a18.488,18.488,0,0,1-4.862,1.068,9.274,9.274,0,0,1-1.353.007,1.967,1.967,0,0,1-.468-.044,2.117,2.117,0,0,1,.468-.029,10.313,10.313,0,0,0,1.338-.08A19.605,19.605,0,0,0,228.988,179c1.967-.7,4.219-1.777,6.844-2.727a20.939,20.939,0,0,1,4.241-1.089c.38-.044.76-.1,1.148-.139s.775-.029,1.17-.044a23.732,23.732,0,0,1,2.384.073,52.4,52.4,0,0,1,8.84,1.865c2.669.746,5.074,1.389,7.136,1.755a27.827,27.827,0,0,0,4.913.468c.548-.022.994-.044,1.345-.059A2.466,2.466,0,0,1,267.484,179.121Z",
    transform: "translate(-222.4 -174.99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7274",
    "data-name": "Group 7274",
    transform: "translate(56.326 13.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11929",
    "data-name": "Path 11929",
    d: "M293.045,153.81c.066.037-.68,1.1-1.382,3.042a15.646,15.646,0,0,0-.709,7.9,16.064,16.064,0,0,0,3.312,7.217c1.294,1.609,2.347,2.376,2.3,2.435a3.866,3.866,0,0,1-.738-.526,14.457,14.457,0,0,1-1.762-1.733,15.449,15.449,0,0,1-3.48-7.326,15.1,15.1,0,0,1,.834-8.058,13.7,13.7,0,0,1,1.1-2.215A3.577,3.577,0,0,1,293.045,153.81Z",
    transform: "translate(-290.366 -153.809)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7275",
    "data-name": "Group 7275",
    transform: "translate(5.974 8.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11930",
    "data-name": "Path 11930",
    d: "M235.941,154.571a2.3,2.3,0,0,1-.651.146,16.41,16.41,0,0,1-1.8.19,9.441,9.441,0,0,1-2.7-.212,5.985,5.985,0,0,1-2.888-1.645c-.848-.834-1.492-1.74-2.142-2.493a8.041,8.041,0,0,0-1.967-1.711,4.958,4.958,0,0,0-2.3-.665,1.562,1.562,0,0,1,.665-.08,4.114,4.114,0,0,1,1.762.512,7.788,7.788,0,0,1,2.1,1.718c.68.753,1.331,1.652,2.142,2.449a5.8,5.8,0,0,0,2.713,1.579,10.131,10.131,0,0,0,2.6.278C235,154.615,235.941,154.512,235.941,154.571Z",
    transform: "translate(-221.5 -148.099)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7277",
    "data-name": "Group 7277",
    transform: "translate(47.344 279.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11931",
    "data-name": "Path 11931",
    d: "M239.17,448.934c-.1,0-.19-7.663-.19-17.117s.088-17.117.19-17.117.19,7.663.19,17.117S239.28,448.934,239.17,448.934Z",
    transform: "translate(-238.98 -414.7)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7278",
    "data-name": "Group 7278",
    transform: "translate(50.583 270.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11932",
    "data-name": "Path 11932",
    d: "M243.6,436.9c-.1,0-.19-7.663-.19-17.117s.088-17.117.19-17.117.19,7.663.19,17.117S243.7,436.9,243.6,436.9Z",
    transform: "translate(-243.41 -402.67)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(11.999 324.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7280",
    "data-name": "Group 7280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11933",
    "data-name": "Path 11933",
    d: "M342.617,477.06c0,.1-65.579.19-146.461.19-80.9,0-146.476-.088-146.476-.19s65.564-.19,146.476-.19C277.031,476.87,342.617,476.95,342.617,477.06Z",
    transform: "translate(-49.68 -476.87)",
    fill: "#263238"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTransaction);
export default __webpack_public_path__ + "static/media/success-transaction.fb4e2c993b6dfb7ecf73ea21a3f5e9f9.svg";
export { ForwardRef as ReactComponent };